<template>
  <main id="main" class="main">
    <section class="section dashboard">
      <div class="row">
        <div class="col-lg-12">
          <h2 v-if="project" class="text-left title">{{ project.project_name || project.name }}</h2>

          <!-- Toggle Buttons -->
          <b-card no-body>
            <b-tabs pills card v-model="tabIndex" class="custom-tabs">
              <!-- Maklumat Inisiatif Tab -->
              <b-tab title="Maklumat Inisiatif" active>
                <b-card-text>
                  <div v-if="project" class="p-3">
                    <form v-if="isEditMode" @submit.prevent="handleSubmit">
                      <!-- <div class="mb-3">
                        <label for="ministry" class="form-label font-weight-bold">Nama Kementerian <span
                            class="text-danger">*</span></label>
                        <b-form-select v-model="project.ministry"
                          :options="[{ value: '', text: 'SILA PILIH' }, ...ministries]" required></b-form-select>
                      </div> -->

                      <!-- Edit Mode: Penyataan Masalah (New Field) -->
                      <div class="mb-3">
                        <label for="problem" class="form-label font-weight-bold">Penyataan Masalah <span
                            class="text-danger">*</span></label>
                        <textarea class="form-control" id="problem" v-model="project.problem" rows="3"
                          @input="validateWordCount('problem')" placeholder="Penyataan Masalah Inisiatif"
                          required></textarea>
                        <small class="form-text text-muted">Jumlah perkataan: {{ problemWordCount }} / 100</small>
                        <small class="form-text text-danger">*Jumlah maksimum yang dibenarkan adalah 100
                          perkataan</small>
                      </div>
                      <!-- Edit Mode: Hasil Cadangan -->
                      <div class="mb-3">
                        <label for="proposal_result" class="form-label font-weight-bold">Cadangan Penyelesaian <span
                            class="text-danger">*</span></label>
                        <textarea class="form-control" id="proposal_result" v-model="project.proposal_result" rows="3"
                          @input="validateWordCount('proposal_result')" placeholder="Hasil Cadangan Inisiatif"
                          required></textarea>
                        <small class="form-text text-muted">Jumlah perkataan: {{ proposalResultWordCount }} /
                          100</small>
                        <small class="form-text text-danger">*Jumlah maksimum yang dibenarkan adalah 100
                          perkataan</small>
                      </div>

                      <!-- Edit Mode: Kos Inisiatif (RM) -->
                      <div class="mb-3">
                        <label for="project_cost" class="form-label font-weight-bold">Kos Inisiatif (RM):</label>
                        <input type="text" class="form-control" id="project_cost" v-model="projectCostInput"
                          @input="updateProjectCost" @blur="validateProjectCost" placeholder="Kos Inisiatif (RM)" />
                      </div>

                      <!-- Edit Mode: Kategori Inisiatif -->
                      <div class="mb-3">
                        <label for="category_id" class="form-label font-weight-bold">Kategori Inisiatif <span
                            class="text-danger">*</span></label>
                        <b-form-select id="category_id" v-model="project.category_id" :options="categoryOptions"
                          required></b-form-select>
                      </div>

                      <!-- Edit Mode: Tahun Mula Inisiatif -->
                      <div class="mb-3">
                        <label for="project_year" class="form-label font-weight-bold">Tahun Mula Inisiatif <span
                            class="text-danger">*</span></label>
                        <b-form-select id="project_year" v-model="project.project_year" :options="projectYears.map(year => ({
                          value: year === 'SILA PILIH' ? '' : year,
                          text: year,
                          disabled: year === 'SILA PILIH'
                        }))" required></b-form-select>
                      </div>

                      <!-- Edit Mode: Kos Inisiatif (RM) -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Lampiran Bukti Inisiatif:</label>
                      </div>

                      <!-- View Mode: Kos Inisiatif (RM) -->
                      <div class="mb-3" v-if="!isEditMode">
                        <label class="form-label font-weight-bold">Kos Inisiatif (RM):</label>
                        <p>{{ formattedProjectCost || 'Tiada maklumat kos inisiatif' }}</p>
                      </div>
                      <!-- Edit Mode: Lampiran Bukti -->
                      <div class="mb-3 attachment-group" v-if="isEditMode">
                        <!-- <label class="form-label font-weight-bold"><strong>Lampiran Bukti Inisiatif:</strong></label> -->

                        <div class="mb-3">
                          <label class="form-label font-weight-bold">Gambar <span class="text-danger">*</span></label>
                          <div v-if="project.images.length > 0" class="attached-files mb-3">
                            <ul class="list-group">
                              <li v-for="(image, index) in project.images" :key="index"
                                class="list-group-item d-flex justify-content-between align-items-center">
                                <span>{{ image.name || `Gambar ${index + 1}` }}</span>
                                <img v-if="image.url" :src="image.url"
                                  style="max-width: 50px; max-height: 50px; margin-right: 10px;">
                                <button type="button" class="btn btn-danger btn-sm"
                                  @click="removeImage(index)">Buang</button>
                              </li>
                            </ul>
                          </div>
                          <div class="drop-area" @dragover.prevent="onDragOver" @dragleave="onDragLeave" @drop="onDrop"
                            @click="triggerFileInput">
                            <p>klik untuk memuat naik gambar</p>
                            <p class="text-muted small">Maksimum 3 gambar (2MB per gambar)</p>
                            <input type="file" ref="fileInput" class="hidden-file-input" accept="image/*" multiple
                              @change="handleImageUpload" />
                          </div>
                          <small class="form-text text-danger">*Saiz maksimum fail adalah 2MB. Format fail yang
                            diterima: jpg, jpeg, png</small>
                        </div>
                        <div class="mb-3">
                          <label class="form-label font-weight-bold">Pautan Video:</label>

                          <!-- TEMPATKAN KODE INPUT VIDEO LINKS DI SINI -->
                          <div v-for="(videoLink, index) in videoLinks" :key="index" class="input-group mb-2">
                            <input type="text" class="form-control" v-model="videoLinks[index]"
                              @blur="validateVideoLink(index)" placeholder="Masukkan pautan video (YouTube)" />
                            <button type="button" class="btn btn-danger" @click="removeVideoLink(index)">
                              <i class="fas fa-times"></i>
                            </button>
                            <small class="text-danger" v-if="videoLinkErrors[index]">
                              {{ videoLinkErrors[index] }}
                            </small>
                          </div>

                          <button type="button" class="btn btn-primary btn-sm" @click="addVideoLink"
                            v-if="videoLinks.length < 3">
                            <i class="fas fa-plus"></i> Tambah Pautan Video
                          </button>
                          <small v-if="videoLinks.length >= 3" class="form-text text-muted">
                            Anda telah memasukkan maksimum 3 pautan video
                          </small>
                          <small class="form-text text-muted">Sila masukkan pautan YouTube sahaja</small>
                        </div>
                        <div class="attachment-item">
                          <label for="testimoni" class="form-label font-weight-bold">Testimoni:</label>
                          <textarea class="form-control" id="testimoni" v-model="project.testimoni" rows="3"
                            @input="validateWordCount('testimoni')" placeholder="Testimoni Pelanggan"></textarea>
                          <small class="form-text text-muted">Jumlah perkataan: {{ testimoniWordCount }} / 100</small>
                          <small class="form-text text-danger">*Jumlah maksimum yang dibenarkan adalah 100
                            perkataan</small>

                        </div>
                        <!-- <label for="image" class="form-label font-weight-bold">Testimoni :</label> -->
                        <div v-if="project.testimoni_images && project.testimoni_images.length > 0"
                          class="attached-files">
                          <ul class="list-group">
                            <li v-for="(image, index) in project.testimoni_images" :key="index"
                              class="list-group-item d-flex justify-content-between align-items-center">
                              <span>{{ image.name || `Testimoni ${index + 1}` }}</span>
                              <img v-if="image.url" :src="image.url"
                                style="max-width: 50px; max-height: 50px; margin-right: 10px;">
                              <button type="button" class="btn btn-danger btn-sm"
                                @click="removeTestimoniImage(index)">Buang</button>
                            </li>
                          </ul>
                        </div>

                        <div class="drop-area" @dragover.prevent="onDragOver" @dragleave="onDragLeave"
                          @drop="onTestimoniDrop" @click="triggerTestimoniFileInput">
                          <p>klik untuk memuat naik gambar</p>
                          <p class="text-muted small">Maksimum 3 gambar (2MB per gambar)</p>
                          <input type="file" ref="testimoniFileInput" class="hidden-file-input" accept="image/*"
                            multiple @change="handleTestimoniUpload" />
                        </div>
                        <small class="form-text text-danger">*Saiz maksimum fail adalah 2MB. Format fail yang
                          diterima:
                          jpg, jpeg, png</small>


                      </div>
                      <!-- Edit Mode: Slaid PDF -->
                      <div class="attachment-item mb-2">
                        <label for="slide_pdf" class="form-label font-weight-bold">Slaid Inisiatif (PDF):</label>
                        <div v-if="project.slide_url" class="attached-files">
                          <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                              <span>{{ getPdfFileName(project.slide_url) || 'Slaid PDF' }}</span>
                              <button type="button" class="btn btn-danger btn-sm" @click="removePdf">Buang</button>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="no-image-text">Tiada slide tersedia</div>
                        <div class="drop-area" @dragover.prevent="onDragOver" @dragleave="onDragLeave" @drop="onPdfDrop"
                          @click="triggerPdfInput">
                          <p>Klik untuk memuat naik fail PDF</p>
                          <input type="file" ref="pdfInput" class="hidden-file-input" accept=".pdf"
                            @change="handlePdfUpload" />
                        </div>
                        <small class="form-text text-danger">*Saiz maksimum fail adalah 5MB. Format fail yang diterima:
                          pdf</small>
                      </div>
                    </form>
                    <!-- View Mode -->
                    <div v-else>
                      <!-- Kenyataan Masalah -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Penyataan Masalah:</label>
                        <p>{{ project.problem || 'Tiada maklumat kenyataan masalah' }}</p>
                      </div>

                      <!-- Hasil Cadangan -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Cadangan Penyelesaian:</label>
                        <p>{{ project.proposal_result || 'Tiada maklumat cadangan penyelesaian' }}</p>
                      </div>

                      <!-- Kos Inisiatif -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Kos Inisiatif (RM):</label>
                        <p>{{ formattedProjectCost || 'Tiada maklumat kos inisiatif' }}</p>
                      </div>

                      <!-- View Mode: Kategori Inisiatif -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Kategori Inisiatif:</label>
                        <p>{{ project.category_name || 'Tiada maklumat kategori inisiatif' }}</p>
                      </div>

                      <!-- View Mode: Tahun Inisiatif -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Tahun Mula Inisiatif:</label>
                        <p>{{ project.project_year || 'Tiada maklumat tahun inisiatif' }}</p>
                      </div>
                      <!-- Hasil Cadangan -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Lampiran Bukti Inisiatif:</label>
                      </div>
                      <div class="mb-3 attachment-group">
                        <div class="attachment-item mb-2">
                          <label class="form-label font-weight-bold">Gambar:</label>
                          <div v-if="project.image_url" class="d-flex flex-wrap image-gallery">
                            <div v-for="(img, index) in getImageUrls(project.image_url)" :key="index"
                              class="image-card me-3 mb-3">
                              <p class="image-title"><b>Gambar {{ index + 1 }}:</b></p>
                              <img :src="img" class="img-thumbnail project-image-zoom"
                                style="max-width: 200px; height: auto; border-radius: 8px;" />
                            </div>
                          </div>
                          <p v-else class="no-image-text">Tiada gambar inisiatif</p>
                        </div>
                        <div class="mb-3">
                          <label class="form-label font-weight-bold">Pautan Video:</label>
                          <div v-if="project.video_url">
                            <div v-for="(videoUrl, index) in getVideoUrls(project.video_url)" :key="index" class="mb-3">
                              <iframe :src="getEmbedUrl(videoUrl)" width="500px" height="300px" frameborder="0"
                                allowfullscreen></iframe>
                            </div>
                          </div>
                          <p v-else>Tiada pautan video tersedia</p>
                        </div>
                        <div class="attachment-item">
                          <label class="form-label font-weight-bold">Testimoni :</label>
                          <p>{{ project.testimoni || 'Tiada testimoni tersedia' }}</p>
                        </div>
                        <!-- <label class="form-label font-weight-bold">Testimoni:</label> -->
                        <div v-if="project.testimoni_image_url" class="d-flex flex-wrap image-gallery">
                          <div v-for="(img, index) in getImageUrls(project.testimoni_image_url)" :key="index"
                            class="image-card me-3 mb-3">
                            <p class="image-title"><b>Testimoni {{ index + 1 }}:</b></p>
                            <img :src="img" class="img-thumbnail project-image-zoom"
                              style="max-width: 200px; height: auto; border-radius: 8px;" />
                          </div>
                        </div>
                        <p v-else class="no-image-text">Tiada gambar testimoni tersedia</p>
                      </div>
                      <!-- View Mode: Slaid PDF -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Slaid Inisiatif (PDF):</label>
                        <div v-if="project.slide_url" class="pdf-viewer-container">
                          <!-- <p><b>Nama Fail:</b> {{ getPdfFileName(project.slide_url) }}</p> -->
                          <iframe :src="getPdfUrl(project.slide_url)" width="100%" height="500px" frameborder="0"
                            style="border: 1px solid #ddd; border-radius: 8px;"></iframe>

                        </div>
                        <p v-else class="no-image-text">Tiada slaid PDF tersedia</p>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>

              <!-- Maklumat Organisasi -->
              <b-tab title="Maklumat Organisasi">
                <b-card-text>
                  <div v-if="project" class="p-3">
                    <form v-if="isEditMode" @submit.prevent="handleSubmit">
                      <!-- Nama Kementerian (Sembunyikan jika isEditMode dan userIcNumber wujud) -->
                      <div class="mb-3" v-if="shouldShowMinistryField && !userIcNumber">
                        <label for="ministry" class="form-label font-weight-bold">Nama Organisasi <span
                            class="text-danger">*</span></label>
                        <b-form-select v-model="project.ministry"
                          :options="[{ value: '', text: 'SILA PILIH' }, ...ministries]" required></b-form-select>
                      </div>
                      <!-- Nama Agensi -->
                      <div class="mb-3">
                        <label for="agency" class="form-label font-weight-bold">Nama Agensi</label>
                        <b-form-select id="agency" v-model="project.agency" :options="agencyOptions"
                          :disabled="!project.ministry || (isEditMode && userIcNumber)"
                          :class="{ 'is-invalid': !project.agency && formSubmitted }">
                        </b-form-select>
                        <div class="invalid-feedback" v-if="!project.agency && formSubmitted">
                          Sila pilih agensi
                        </div>
                        <!-- <small v-if="isEditMode && userIcNumber" class="form-text text-muted">
                          Agensi ditetapkan secara automatik berdasarkan profil anda.
                        </small> -->
                      </div>
                      <div class="mb-3" v-if="isEditMode">
                        <label for="state" class="form-label font-weight-bold">Lokasi Inisiatif <span
                            class="text-danger">*</span></label>
                        <b-form-select id="state" v-model="project.state" :options="states" required
                          :class="{ 'is-invalid': !project.state && formSubmitted }"></b-form-select>
                        <div class="invalid-feedback" v-if="!project.state && formSubmitted">
                          Sila pilih negeri lokasi inisiatif
                        </div>
                      </div>
                      <!-- Ketua Pasukan -->
                      <div class="mb-3">
                        <label for="team_leader" class="form-label font-weight-bold">Ketua Pasukan <span
                            class="text-danger">*</span></label>
                        <div v-if="teamLeaderList.length > 0" class="team-leader-list">
                          <ul class="list-group">
                            <li v-for="(leader, index) in teamLeaderList" :key="index"
                              class="list-group-item d-flex justify-content-between align-items-center">
                              <div>
                                <div class="leader-name"><i class="fas fa-user-circle icon-leader"></i> {{ leader.name
                                }}</div>
                                <div class="small text-muted"><i class="fas fa-id-card icon-id"></i> {{ leader.noic }}
                                </div>
                                <div class="small text-muted"><i class="fas fa-envelope icon-email"></i> {{ leader.email
                                }}</div>
                                <div v-if="leader.phone" class="small text-muted"><i
                                    class="fas fa-phone icon-phone"></i> {{ leader.phone }}</div>
                                <div v-if="leader.extension" class="small text-muted"><i
                                    class="fas fa-headset icon-extension"></i> {{ leader.extension }}</div>
                              </div>
                              <button type="button" class="btn btn-danger btn-sm"
                                @click="removeTeamLeader(index)">Padam</button>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-muted">Tiada ketua pasukan ditambah lagi.</div>
                        <button type="button" class="btn custom-outline-btn leader mt-2" @click="showSearchModal"
                          v-text="isEditMode && userIcNumber ? 'Tambah Ketua' : 'Cari Ketua'"></button>
                      </div>

                      <!-- Ahli Pasukan -->
                      <div class="mb-3">
                        <label for="team_members" class="form-label font-weight-bold">Ahli Pasukan <span
                            class="text-danger">*</span></label>
                        <div v-if="teamMembersList.length > 0" class="team-members-list">
                          <ul class="list-group">
                            <li v-for="(member, index) in teamMembersList" :key="index"
                              class="list-group-item d-flex justify-content-between align-items-center">
                              <div>
                                <div class="member-name"><i class="fas fa-user icon-member"></i> {{ member.name }}</div>
                                <div class="small text-muted"><i class="fas fa-id-card icon-id"></i> {{ member.noic }}
                                </div>
                              </div>
                              <button type="button" class="btn btn-danger btn-sm"
                                @click="removeTeamMember(index)">Padam</button>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-muted">Tiada ahli pasukan ditambah lagi.</div>
                        <button type="button" class="btn custom-outline-btn member mt-2" @click="showSearchAhliModal"
                          v-text="isEditMode && userIcNumber ? 'Tambah Ahli' : 'Cari Ahli'"></button>
                      </div>
                    </form>
                    <!-- View Mode -->
                    <div v-else>
                      <!-- Nama Kementerian (Sembunyikan jika userIcNumber wujud) -->
                      <div class="mb-3" v-if="shouldShowMinistryField && !userIcNumber">
                        <label class="form-label font-weight-bold">Nama Organisasi</label>
                        <p>{{ project.nama_kementerian || 'Tiada maklumat Organisasi' }}</p>
                      </div>
                      <!-- Nama Agensi -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Nama Agensi</label>
                        <p>{{ project.nama_agensi || 'Tiada maklumat agensi' }}</p>
                      </div>
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Lokasi Inisiatif</label>
                        <p>{{ project.state_name || this.findStateName(project.state) || 'Tiada maklumat negeri' }}</p>
                      </div>
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Ketua Pasukan</label>
                        <div v-if="teamLeader.length" class="team-leader-list">
                          <ul class="list-group">
                            <li v-for="(leader, index) in teamLeader" :key="index"
                              class="list-group-item d-flex justify-content-between align-items-center">
                              <div>
                                <div class="leader-name"><i class="fas fa-user-circle icon-leader"></i> {{
                                  leader.member_name }}</div>
                                <div class="small text-muted"><i class="fas fa-id-card icon-id"></i> {{
                                  leader.member_icno || 'Tiada No Kad Pengenalan' }}</div>
                                <div class="small text-muted"><i class="fas fa-envelope icon-email"></i> {{ leader.email
                                  || 'Tiada Emel' }}</div>
                                <div v-if="leader.phone" class="small text-muted"><i
                                    class="fas fa-phone icon-phone"></i> {{ leader.phone || 'Tiada No Telefon' }}</div>
                                <div v-if="leader.extension" class="small text-muted"><i
                                    class="fas fa-headset icon-extension"></i> {{ leader.extension }}</div>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-muted">Tiada ketua pasukan ditambah lagi.</div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Ahli Pasukan</label>
                        <div v-if="teamMembers.length" class="team-members-list">
                          <ul class="list-group">
                            <li v-for="(member, index) in teamMembers" :key="index"
                              class="list-group-item d-flex justify-content-between align-items-center">
                              <div>
                                <div class="member-name"><i class="fas fa-user icon-member"></i> {{ member.member_name
                                }}</div>
                                <div class="small text-muted"><i class="fas fa-id-card icon-id"></i> {{
                                  member.member_icno || 'Tiada No Kad Pengenalan' }}</div>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-muted">Tiada ahli pasukan ditambah lagi.</div>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>

              <!-- Impak Inisiatif -->
              <b-tab title="Impak Inisiatif">
                <b-card-text>
                  <div v-if="project" class="p-3">
                    <div class="mb-3">
                      <label class="form-label font-weight-bold">
                        <span v-if="isEditMode">Hasil Inisiatif <span class="text-danger">*</span></span>
                        <span v-else>Hasil Inisiatif:</span>
                      </label>
                      <div v-if="isEditMode">
                        <b-form-select v-model="selectedOutput"
                          :options="[{ value: null, text: 'SILA PILIH' }, ...projectOutputs.map(o => ({ value: o.id, text: o.output_name }))]"
                          required></b-form-select>
                      </div>
                      <div v-else>
                        <!-- Fix: Ensure we show the output name properly -->
                        <p v-if="selectedOutput">{{ getOutputName(selectedOutput) || 'Tiada hasil inisiatif dipilih' }}
                        </p>
                        <p v-else class="text-muted">Tiada hasil inisiatif dipilih</p>
                      </div>
                    </div>
                    <form v-if="isEditMode" @submit.prevent="handleSubmit">


                      <!-- Edit Mode: Sebelum Pelaksanaan -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Sebelum Pelaksanaan Inisiatif <span
                            class="text-danger">*</span></label>
                        <div v-if="beforeProjectList.length > 0" class="before-project-list">
                          <ul class="list-group">
                            <li v-for="(item, index) in beforeProjectList" :key="index"
                              class="list-group-item d-flex justify-content-between align-items-center">
                              <span>{{ index + 1 }}. {{ item }}</span>
                              <button type="button" class="btn btn-danger btn-sm"
                                @click="removeBeforeItem(index)">Padam</button>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-muted">Tiada maklumat sebelum pelaksanaan ditambah lagi.</div>
                        <button type="button" class="btn btn-outline-secondary mt-2"
                          @click="showBeforeModal">Tambah</button>
                      </div>
                      <!-- Edit Mode: Selepas Pelaksanaan -->
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Selepas Pelaksanaan Inisiatif<span
                            class="text-danger">*</span></label>
                        <div v-if="afterProjectList.length > 0" class="after-project-list">
                          <ul class="list-group">
                            <li v-for="(item, index) in afterProjectList" :key="index"
                              class="list-group-item d-flex justify-content-between align-items-center">
                              <span>{{ index + 1 }}. {{ item }}</span>
                              <button type="button" class="btn btn-danger btn-sm"
                                @click="removeAfterItem(index)">Padam</button>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-muted">Tiada maklumat selepas pelaksanaan ditambah lagi.</div>
                        <button type="button" class="btn btn-outline-secondary mt-2"
                          @click="showAfterModal">Tambah</button>
                      </div>
                    </form>
                    <!-- View Mode -->
                    <div v-else>
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Sebelum Pelaksanaan
                          Inisiatif:</label>
                        <div v-if="beforeProjectImpacts.length" class="before-project-list">
                          <ul class="list-group">
                            <li v-for="(item, index) in beforeProjectImpacts" :key="index"
                              class="list-group-item d-flex justify-content-between align-items-center">
                              <span>{{ index + 1 }}. {{ item }}</span>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-muted">Tiada maklumat sebelum pelaksanaan ditambah lagi.</div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label font-weight-bold">Selepas Pelaksanaan
                          Inisiatif:</label>
                        <div v-if="afterProjectImpacts.length" class="after-project-list">
                          <ul class="list-group">
                            <li v-for="(item, index) in afterProjectImpacts" :key="index"
                              class="list-group-item d-flex justify-content-between align-items-center">
                              <span>{{ index + 1 }}. {{ item }}</span>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-muted">Tiada maklumat selepas pelaksanaan ditambah lagi.</div>
                      </div>

                    </div>
                  </div>
                </b-card-text>
              </b-tab>

              <!-- Dalam tab Kriteria H.E.M.A.T. -->
              <!-- Kriteria H.E.M.A.T. (Hanya untuk Admin, tetapi kandungan Keputusan Penilaian untuk Bukan Admin) -->
              <b-tab v-if="isAdmin" title="Penilaian Kriteria H.E.M.A.T." class="tab-content-bg">

                <div class="secretariat-header">TINDAKAN SEKRETARIAT</div>
                <div v-if="project" class="p-3">
                  <!-- Tambahkan ayat arahan di sini -->
                  <p class="font-weight-bold text-primary mb-3">
                    Penilai perlu menilai semua nilai H.E.M.A.T. bagi setiap inisiatif yang didaftarkan.
                  </p>
                  <div class="d-flex justify-content-between">
                    <label class="form-label font-weight-bold">Kriteria H.E.M.A.T. yang Dipenuhi:</label>
                    <label class="form-label font-weight-bold">Penilaian Sekretariat</label>
                  </div>
                  <ul class="list-group">
                    <li v-for="(criterion, index) in criteria" :key="index"
                      class="list-group-item d-flex align-items-center position-relative">
                      <span class="tooltip-trigger flex-grow-1">{{ criterion.name }}</span>
                      <div class="tooltip-custom">{{ criterion.description }}</div>
                      <div class="star-rating ml-3">
                        <span v-for="star in 5" :key="star" @click="setRating(criterion, star)"
                          @mouseover="hoverRating(criterion, star)" @mouseleave="resetRating(criterion)" :class="{
                            'text-warning': star <= (criterion.hoverRating || criterion.rating),
                            'fas': star <= (criterion.hoverRating || criterion.rating),
                            'far': star > (criterion.hoverRating || criterion.rating),
                            'fa-star': true
                          }" class="rating-star">
                        </span>
                        <i v-if="criterion.rating > 0" class="fas fa-undo reset-rating ml-2"
                          @click="resetStarRating(criterion)" title="Reset rating"></i>
                        <small class="text-muted ml-2">{{ criterion.rating || 0 }}/5</small>
                      </div>
                    </li>
                  </ul>
                  <!-- Tambah petunjuk visual -->
                  <!-- <small class="form-text text-danger mt-2">* Sila berikan rating untuk semua kriteria H.E.M.A.T.
                    sebelum mengemukakan penilaian.</small> -->
                  <!-- Penilaian Inisiatif -->
                  <!-- <div class="mt-4 penilaian-projek-container">
                    <div class="penilaian-projek-card">
                      <h5 class="penilaian-projek-title">Penilaian Inisiatif</h5>
                      <div class="penilaian-projek-content">
                        <div class="rating-item">
                          <span class="rating-label">Markah:</span>
                          <span class="rating-value">{{ overallRating.score }}</span>
                        </div>
                        <div class="rating-item">
                          <span class="rating-label">Markah Keseluruhan:</span>
                          <span class="rating-value">{{ overallRating.weightedScore }}</span>
                        </div>
                        <div class="rating-item">
                          <span class="rating-label">Kategori:</span>
                          <span class="rating-value" :class="getRatingCategoryClass(overallRating.category)">
                            {{ overallRating.category }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- Tindakan Sekretariat (only shown for admin) -->
                  <div v-if="isAdmin" class="mt-4 secretariat-section">
                    <div class="secretariat-content p-3">
                      <!-- Penilaian Inisiatif (Same as Kriteria H.E.M.A.T.) -->
                      <div class="penilaian-projek-container">
                        <div class="penilaian-projek-card">
                          <h5 class="penilaian-projek-title">Penilaian Inisiatif</h5>
                          <div class="penilaian-projek-content">
                            <div class="rating-item">
                              <span class="rating-label">Markah:</span>
                              <span class="rating-value">{{ overallRating.score }}</span>
                            </div>
                            <div class="rating-item">
                              <span class="rating-label">Markah Keseluruhan:</span>
                              <span class="rating-value">{{ overallRating.weightedScore }}</span>
                            </div>
                            <div class="rating-item">
                              <span class="rating-label">Kategori:</span>
                              <span class="rating-value" :class="getRatingCategoryClass(overallRating.category)">
                                {{ overallRating.category }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="status-section">
                        <div class="form-group">
                          <label class="font-weight-bold">Nilai H.E.M.A.T. Inisiatif :
                            <span :class="{
                              'text-success': computedStatus === 'disahkan',
                              'text-danger': computedStatus === 'tidak disahkan',
                              'text-muted': computedStatus === 'Belum Dinilai'
                            }">
                              {{ computedStatus === 'disahkan' ? '✅ Memenuhi' :
                                computedStatus === 'tidak disahkan' ? '❌ Tidak Memenuhi' :
                                  '⏳ Belum Dinilai' }}
                            </span>
                          </label>
                        </div>

                        <div class="form-group mt-3">
                          <label class="font-weight-bold">Ulasan</label>
                          <textarea class="form-control" v-model="adminComment" rows="4"
                            @input="validateCommentWordCount"
                            :disabled="project.status === 'disahkan' || project.status === 'tidak disahkan'"
                            placeholder="Masukkan ulasan anda..."></textarea>
                          <div class="word-count mt-1">
                            <small class="text-muted">Jumlah perkataan: {{ adminCommentWordCount }} / 100</small>
                            <small class="text-danger d-block">*Jumlah maksimum yang dibenarkan adalah 100
                              perkataan</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>



              <!-- Tab Keputusan Penilaian -->
              <b-tab v-if="!isAdmin && ['disahkan', 'tidak disahkan'].includes(project.status)"
                title="Keputusan Penilaian" class="tab-content-bg">
                <div v-if="project" class="p-3">
                  <div class="d-flex justify-content-between">
                    <label class="form-label font-weight-bold">Kriteria H.E.M.A.T. yang Dipenuhi:</label>
                    <label v-if="isAdmin" class="form-label font-weight-bold">Penilaian Sekretariat</label>
                  </div>
                  <ul class="list-group">
                    <li v-for="(criterion, index) in criteria" :key="index"
                      class="list-group-item d-flex align-items-center position-relative">
                      <!-- Checkbox for Admin Approval -->
                      <!-- <div class="checkbox-group mr-3">
                        <b-form-checkbox v-model="criterion.admin_approved" switch class="mr-2" disabled
                          :checked="criterion.admin_approved">
                        </b-form-checkbox>
                      </div> -->
                      <span class="tooltip-trigger flex-grow-1">{{ criterion.name }}</span>
                      <div class="tooltip-custom">{{ criterion.description }}</div>

                      <!-- Star Rating (Readonly) -->
                      <div class="star-rating ml-3">
                        <span v-for="star in 5" :key="star" :class="{
                          'text-warning': star <= criterion.rating,
                          'fas': star <= criterion.rating,
                          'far': star > criterion.rating,
                          'fa-star': true
                        }" class="rating-star">
                        </span>
                        <small class="text-muted ml-2">{{ criterion.rating || 0 }}/5</small>
                      </div>
                    </li>
                  </ul>

                  <!-- Penilaian Inisiatif -->
                  <div class="mt-4 penilaian-projek-container">
                    <div class="penilaian-projek-card">
                      <h5 class="penilaian-projek-title">Penilaian Inisiatif</h5>
                      <div class="penilaian-projek-content">
                        <div class="rating-item">
                          <span class="rating-label">Markah:</span>
                          <span class="rating-value">{{ overallRating.score }}</span>
                        </div>
                        <div class="rating-item">
                          <span class="rating-label">Markah Keseluruhan:</span>
                          <span class="rating-value">{{ overallRating.weightedScore }}</span>
                        </div>
                        <div class="rating-item">
                          <span class="rating-label">Kategori:</span>
                          <span class="rating-value" :class="getRatingCategoryClass(overallRating.category)">
                            {{ overallRating.category }}
                          </span>
                        </div>
                        <div class="rating-item">
                          <span class="rating-label">Status Penilaian:</span>
                          <span class="rating-value" :class="{
                            'text-success': project.status === 'disahkan',
                            'text-danger': project.status === 'tidak disahkan'
                          }">
                            {{ project.status === 'disahkan' ? 'Memenuhi' :
                              project.status === 'tidak disahkan' ? 'Tidak Memenuhi' : 'Belum Dinilai' }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Ulasan Sekretariat -->
                  <div v-if="(project.status === 'tidak disahkan' || project.status === 'disahkan') && adminComment"
                    class="mt-4">
                    <div class="secretariat-header">ULASAN SEKRETARIAT</div>
                    <div class="secretariat-content p-3">
                      <p>{{ adminComment }}</p>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
          <div class="d-flex justify-content-between mt-3">
            <b-button-group class="button-group-custom">
              <!-- Butang di sini -->
            </b-button-group>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <b-button-group>

              <!-- Admin buttons -->
              <div v-if="isAdmin" class="mt-4 secretariat-section">
                <div class="d-flex justify-content-end mt-3">
                  <b-button v-if="tabIndex !== 0" variant="secondary" @click="prevTab">Sebelum</b-button>
                  <b-button variant="primary" @click="$router.push('/senarai-projek')" class="me-2">
                    Kembali
                  </b-button>
                  <!-- Show Hantar button only on Impak Inisiatif tab (tabIndex === 3) -->
                  <b-button
                    v-if="tabIndex === 3 && project.status !== 'disahkan' && project.status !== 'tidak disahkan'"
                    variant="success" @click="submitApproval" :disabled="!isAllCriteriaRated || isSubmitting">
                    Sahkan
                  </b-button>
                  <b-button v-if="tabIndex !== 3" variant="primary" @click="nextTab">Seterusnya</b-button>
                </div>
              </div>

              <div v-else class="mt-4">
                <div class="d-flex justify-content-end mt-3">
                  <!-- Show Previous button if not on the first tab -->
                  <b-button v-if="tabIndex !== 0" variant="secondary" @click="prevTab">Sebelum</b-button>

                  <!-- Show buttons based on ownership -->
                  <template v-if="project && project.owner === 'sama'">
                    <!-- Non-admin buttons for owner -->
                    <b-button v-if="!isEditMode && !['baru', 'disahkan', 'tidak disahkan'].includes(project.status)"
                      variant="warning" @click="toggleEditMode" class="me-2">
                      Kemaskini
                    </b-button>
                    <!-- Hantar button in View Mode -->
                    <b-button v-if="!isEditMode && !['baru', 'disahkan', 'tidak disahkan'].includes(project.status)"
                      variant="success" @click="submitProjectFromViewMode" :disabled="isSubmitting" class="me-2">
                      Hantar
                    </b-button>
                    <!-- Simpan and Hantar buttons in Edit Mode, hidden for specific statuses -->
                    <b-button v-if="isEditMode && !['baru', 'disahkan', 'tidak disahkan'].includes(project.status)"
                      variant="success" @click="submitProject('draf')" :disabled="isSubmitting" class="me-2">
                      Simpan
                    </b-button>
                    <b-button v-if="isEditMode && !['baru', 'disahkan', 'tidak disahkan'].includes(project.status)"
                      variant="success" @click="submitProject('baru')" :disabled="isSubmitting" class="me-2">
                      Hantar
                    </b-button>
                    <!-- Batal button in Edit Mode -->
                    <b-button v-if="isEditMode" variant="danger" @click="cancelEditMode" class="me-2">
                      Batal
                    </b-button>
                  </template>

                  <!-- Always show Kembali button -->
                  <b-button variant="primary" @click="$router.push('/senarai-projek')" class="me-2">
                    Kembali
                  </b-button>

                  <!-- Show Next button if not on the last tab -->
                  <b-button v-if="tabIndex !== 3" variant="primary" @click="nextTab">Seterusnya</b-button>
                </div>
              </div>

            </b-button-group>
          </div>
        </div>
      </div>
    </section>

    <!-- Modal untuk Carian Ketua Pasukan --><b-modal ref="searchModal"
      :title="isIcNumberPresent ? 'Tambah Ketua Pasukan' : 'Cari Ketua Pasukan'" hide-footer>
      <div v-if="isIcNumberPresent"> <!-- Form Input Manual untuk Ketua Pasukan -->
        <form @submit.prevent="addManualLeader">
          <div class="mb-3"> <label for="manualLeaderName" class="form-label font-weight-bold">Nama <span
                class="text-danger">*</span></label> <input type="text" class="form-control" id="manualLeaderName"
              v-model="manualLeader.name" placeholder="Masukkan nama ketua pasukan" required
              @input="capitalizeName('leader')" /> </div>
          <div class="mb-3"> <label for="manualLeaderNoic" class="form-label font-weight-bold">No Kad Pengenalan <span
                class="text-danger">*</span></label> <input type="text" class="form-control" id="manualLeaderNoic"
              v-model="manualLeader.noic" placeholder="Masukkan No Kad Pengenalan" required maxlength="12"
              @input="validateManualNoKP($event, 'leader')" /> </div>
          <div class="mb-3"> <label for="manualLeaderEmail" class="form-label font-weight-bold">Emel <span
                class="text-danger">*</span></label> <input type="email" class="form-control" id="manualLeaderEmail"
              v-model="manualLeader.emel" placeholder="Masukkan alamat emel" required /> </div>
          <div class="mb-3"> <label for="manualLeaderPhone" class="form-label font-weight-bold">No Telefon <span
                class="text-danger">*</span></label> <input type="tel" class="form-control" id="manualLeaderPhone"
              v-model="manualLeader.phone" placeholder="Contoh: 0123456789" required pattern="[0-9]*"
              inputmode="numeric" @input="validateManualPhoneNumber($event)"
              @blur="validateManualPhoneNumber($event)" /> <small v-if="phoneErrorMessage" class="text-danger">{{
                phoneErrorMessage }}</small> </div>
          <div class="mb-3"> <label for="manualLeaderExtension" class="form-label font-weight-bold">Sambungan (Jika
              Ada)</label> <input type="text" class="form-control" id="manualLeaderExtension"
              v-model="manualLeader.extension" placeholder="Contoh: 1234" @input="validateManualExtension($event)"
              maxlength="4" /> </div> <button type="submit" class="btn btn-success"
            :disabled="!isManualLeaderFormValid">Tambah Ketua</button> <button type="button"
            class="btn btn-secondary ml-2" @click="$refs.searchModal.hide()">Batal</button>
        </form>
      </div>
      <div v-else> <!-- Form Carian Asal untuk Pengguna Tanpa icNumber -->
        <form @submit.prevent="searchTeamLeader">
          <div class="mb-3"> <label for="searchNoKP" class="form-label font-weight-bold">No Kad Pengenalan</label>
            <input type="text" class="form-control" id="searchNoKP" v-model="searchNoKP"
              placeholder="Sila Masukkan No Kad Pengenalan" required maxlength="12" @input="validateNoKP($event)" />
          </div> <button type="submit" class="btn btn-primary">Cari</button>
        </form>
        <div v-if="searchResultLeader" class="mt-3">
          <p><strong>Nama:</strong> {{ searchResultLeader.name }}</p>
          <p><strong>No Kad Pengenalan:</strong> {{ searchResultLeader.nokp }}</p>
          <p><strong>Emel:</strong> {{ searchResultLeader.emel }}</p>
          <div class="mb-3"> <label for="leaderPhone" class="form-label font-weight-bold">No Telefon <span
                class="text-danger">*</span></label> <input type="text" class="form-control" id="leaderPhone"
              v-model="searchResultLeader.phone" placeholder="Contoh: 0388855000" required @input="validatePhoneNumber"
              @blur="validatePhoneNumber" /> </div>
          <div class="mb-3"> <label for="leaderExtension" class="form-label font-weight-bold">Sambungan (Jika
              Ada)</label> <input type="text" class="form-control" id="leaderExtension"
              v-model="searchResultLeader.extension" placeholder="Contoh: 1234" @input="validateExtension($event)"
              maxlength="4" /> </div> <button type="button" class="btn btn-success" @click="selectTeamLeader"
            :disabled="!searchResultLeader || searchResultLeader.name === 'Tiada Maklumat Pengguna'">Pilih</button>
        </div>
      </div>
    </b-modal>

    <!-- Modal untuk Carian Ahli Pasukan -->
    <!-- Modal untuk Carian Ahli Pasukan -->
    <b-modal ref="searchAhliModal" :title="isIcNumberPresent ? 'Tambah Ahli Pasukan' : 'Cari Ahli Pasukan'" hide-footer>
      <div v-if="isIcNumberPresent">
        <form @submit.prevent="addManualMember">
          <div class="mb-3">
            <label for="manualMemberName" class="form-label font-weight-bold">Nama <span
                class="text-danger">*</span></label>
            <input type="text" class="form-control" id="manualMemberName" v-model="manualMember.name"
              placeholder="Masukkan nama ahli pasukan" required @input="capitalizeName('member')" />
            <small class="form-text text-muted">Hanya huruf dibenarkan</small>
          </div>
          <div class="mb-3">
            <label for="manualMemberNoic" class="form-label font-weight-bold">No Kad Pengenalan <span
                class="text-danger">*</span></label>
            <input type="text" class="form-control" id="manualMemberNoic" v-model="manualMember.noic"
              placeholder="Masukkan No Kad Pengenalan" required maxlength="12"
              @input="validateManualNoKP($event, 'member')" />
          </div>
          <div class="mb-3">
            <label for="manualMemberEmail" class="form-label font-weight-bold">Emel</label>
            <input type="email" class="form-control" id="manualMemberEmail" v-model="manualMember.emel"
              placeholder="Masukkan alamat emel" />
          </div>
          <button type="submit" class="btn btn-success" :disabled="!isManualMemberFormValid">Tambah Ahli</button>
          <button type="button" class="btn btn-secondary ml-2" @click="$refs.searchAhliModal.hide()">Batal</button>
        </form>
      </div>

      <div v-else>
        <form @submit.prevent="searchTeamMember">
          <div class="mb-3">
            <label for="searchNoKPMember" class="form-label font-weight-bold">No Kad Pengenalan</label>
            <input type="text" class="form-control" id="searchNoKPMember" v-model="searchNoKPMember"
              placeholder="Sila Masukkan No Kad Pengenalan" required maxlength="12" @input="validateNoKP($event)" />
          </div>
          <button type="submit" class="btn btn-primary">Cari</button>
        </form>

        <div v-if="searchResultMember" class="mt-3">
          <p><strong>Nama:</strong> {{ searchResultMember.name }}</p>
          <p><strong>No Kad Pengenalan:</strong> {{ searchResultMember.nokp }}</p>
          <p><strong>Emel:</strong> {{ searchResultMember.emel || 'Tiada maklumat emel' }}</p>

          <button type="button" class="btn btn-success" @click="selectTeamMember"
            :disabled="!searchResultMember || searchResultMember.name === 'Tiada Maklumat Pengguna'">
            Pilih Ahli
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="beforeModal" title="Tambah Maklumat Sebelum Pelaksanaan" hide-footer>
      <form @submit.prevent="addBeforeInfo">
        <div class="mb-3">
          <label for="beforeInfo" class="form-label font-weight-bold">Maklumat Sebelum Pelaksanaan</label>
          <textarea class="form-control" id="beforeInfo" v-model="beforeInfo" rows="3" placeholder="Masukkan maklumat"
            @input="validateBeforeInfoWordCount" required></textarea>
          <small class="form-text text-muted">Jumlah perkataan: {{ beforeInfoWordCount }} / 100</small>
          <small class="form-text text-danger">*Jumlah maksimum yang dibenarkan adalah 100 perkataan</small>
        </div>
        <button type="submit" class="btn btn-primary">Tambah</button>
        <button type="button" class="btn btn-secondary ml-2" @click="$refs.beforeModal.hide()">Batal</button>
      </form>
    </b-modal>

    <b-modal ref="afterModal" title="Tambah Maklumat Selepas Pelaksanaan" hide-footer>
      <form @submit.prevent="addAfterInfo">
        <div class="mb-3">
          <label for="afterInfo" class="form-label font-weight-bold">Maklumat Selepas Pelaksanaan</label>
          <textarea class="form-control" id="afterInfo" v-model="afterInfo" rows="3" placeholder="Masukkan maklumat"
            @input="validateAfterInfoWordCount" required></textarea>
          <small class="form-text text-muted">Jumlah perkataan: {{ afterInfoWordCount }} / 100</small>
          <small class="form-text text-danger">*Jumlah maksimum yang dibenarkan adalah 100 perkataan</small>
        </div>
        <button type="submit" class="btn btn-primary">Tambah</button>
        <button type="button" class="btn btn-secondary ml-2" @click="$refs.afterModal.hide()">Batal</button>
      </form>
    </b-modal>
  </main>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { baseURLProjectPdf } from '../../../services/baseURL';
import { baseURL } from '../../../services/baseURL';

export default {
  name: 'ProjectViewEdit',
  data() {
    return {
      userIcNumber: null,
      formSubmitted: false,
      videoLinks: [''],
      videoLinkErrors: [],
      // agencyOptions: [{ value: '', text: 'SILA PILIH KEMENTERIAN TERLEBIH DAHULU', disabled: true }],
      agencyOptions: [],
      beforeInfoWordCount: 0,
      afterInfoWordCount: 0,
      adminCommentWordCount: 0,
      selectedOutput: null,
      projectOutputs: [],
      testimoniImages: [],
      proposalResultWordCount: 0,
      formattedProjectCost: '',
      tabIndex: 0,
      isEditMode: false,
      project: {
        project_year: null,
        category_id: '',
        images: [],
        testimoni_images: [],
      },
      projectYears: [],
      projectCategories: [],
      projectCostInput: '',
      teamLeader: [],
      teamMembers: [],
      teamLeaderList: [],
      teamMembersList: [],
      beforeProjectList: [],
      afterProjectList: [],
      beforeProjectImpacts: [],
      afterProjectImpacts: [],
      criteria: [
        {
          name: 'Hijrah Tata Kelola',
          user_selection: false,
          admin_approved: false,
          rating: 0,
          hoverRating: 0,
          description: 'Keberanian untuk berubah sama ada daripada aspek prosedur, cara bekerja dan jalinan komunikasi.'
        },
        {
          name: 'Empati Rakyat',
          user_selection: false,
          admin_approved: false,
          rating: 0,
          hoverRating: 0,
          description: 'Meletakkan diri penjawat awam di tempat pelanggan atau sebagai penerima perkhidmatan.'
        },
        {
          name: 'Minda Pekin',
          user_selection: false,
          admin_approved: false,
          rating: 0,
          hoverRating: 0,
          description: 'Berjimat-cermat dalam membelanjakan dana secara kreatif dan inovatif dengan memanfaatkan sumber sedia ada serta menjalankan tugas dengan bersikap cermat.'
        },
        {
          name: 'Apresiasi Inovasi',
          user_selection: false,
          admin_approved: false,
          rating: 0,
          hoverRating: 0,
          description: 'Sikap menyokong dan menghargai perkembangan idea-idea baharu bagi memperkasakan perkhidmatan awam, meneroka pelbagai inisiatif baharu yang bersesuaian dengan kehendak semasa dan berusaha untuk memartabatkan inisiatif digital baharu yang cekap.'
        },
        {
          name: 'Telus Tadbiran',
          user_selection: false,
          admin_approved: false,
          rating: 0,
          hoverRating: 0,
          description: 'Memerlukan penjawat awam berusaha untuk menyematkan nilai integriti dalam menjalankan tugas seharian, sentiasa membudayakan amalan semak dan imbang bagi melancarkan pelaksanaan tugas dan meraikan pandangan luar yang dapat memantapkan lagi kualiti kerja yang dijalankan.'
        },
      ],
      status: "",
      selectedCriteria: [],
      ministries: [],
      agencies: [],
      states: [],
      problemWordCount: 0,
      testimoniWordCount: 0,
      errorMessage: '',
      isDragging: false,
      isSubmitting: false,
      searchResultLeader: null,
      searchResultMember: null,
      searchNoKP: '',
      searchNoKPMember: '',
      beforeInfo: '',
      afterInfo: '',
      isAdmin: false,
      adminComment: '',
      manualLeader: {
        name: '',
        noic: '',
        emel: '',
        phone: '',
        extension: ''
      },
      manualMember: {
        name: '',
        noic: '',
        emel: ''
      },
      phoneErrorMessage: ''
    };
  },
  mounted() {
    this.checkUserRole();
    this.fetchUserIcNumber();
    this.fetchProjectDetails();
    this.fetchTeamDetails();
    this.fetchCriteriaLockup();
    this.fetchProjectImpacts();
    this.fetchMinistries();
    this.fetchStates();
    this.fetchProjectCategories();
    this.generateProjectYears();
    this.fetchProjectOutputs();

    // console.log('Base URL:', this.getBaseUrl());
    // console.log('Image URLs:', this.project.image_url);
    // console.log('Full Image URLs:', this.getImageUrls(this.project.image_url));
    // console.log('PDF URL:', this.getPdfUrl(this.project.slide_url));
  },
  watch: {
    'project.ministry': function (newVal) {
      // console.log('Ministry changed:', newVal);
      this.project.agency = null; // Kosongkan agensi apabila kementerian berubah
      this.fetchAgencies(newVal);
    },
    'project.project_cost': function (newVal) {
      this.formattedProjectCost = this.formatCurrency(newVal);
    },
  },
  computed: {
    shouldShowMinistryField() {
      // Tampilkan field kementerian jika:
      // - Bukan user_type public ATAU
      // - Bukan admin
      return !(this.project.user_type === 'public' && this.isAdmin);
    },
    isIcNumberPresent() {
      return !!this.userIcNumber;
    },
    isManualLeaderFormValid() {
      return (
        this.manualLeader.name.trim() !== '' &&
        /^[a-zA-Z\s]+$/.test(this.manualLeader.name) &&
        this.manualLeader.noic.length === 12 &&
        /^\d{12}$/.test(this.manualLeader.noic) &&
        this.manualLeader.emel.trim() !== '' &&
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.manualLeader.emel) &&
        this.manualLeader.phone.trim() !== '' &&
        /^\d{10,12}$/.test(this.manualLeader.phone)
      );
    },
    isManualMemberFormValid() {
      return (
        this.manualMember.name.trim() !== '' &&
        /^[a-zA-Z\s]+$/.test(this.manualMember.name) &&
        this.manualMember.noic.length === 12 &&
        /^\d{12}$/.test(this.manualMember.noic)
      );
    },
    isAllCriteriaRated() {
      return this.criteria.every(c => c.rating > 0);
    },
    overallRating() {
      // Filter criteria with rating > 1 (rating 1 is considered as not meeting criteria)
      const ratedCriteria = this.criteria.filter(c => c.rating > 1);

      if (ratedCriteria.length === 0) {
        return {
          score: '0/0',
          weightedScore: '0',
          category: 'Perlu Penambahbaikan'
        };
      }

      const totalRating = ratedCriteria.reduce((sum, criterion) => sum + criterion.rating, 0);
      const totalPossible = ratedCriteria.length * 5;
      const weightedScore = (totalRating / totalPossible) * 25;
      const roundedWeightedScore = Math.round(weightedScore);

      const formattedWeightedScore = Number.isInteger(roundedWeightedScore)
        ? roundedWeightedScore.toString()
        : roundedWeightedScore.toFixed(2);

      let category;
      if (weightedScore >= 21) {
        category = 'Cemerlang';
      } else if (weightedScore >= 16) {
        category = 'Baik';
      } else if (weightedScore >= 11) {
        category = 'Sederhana';
      } else if (weightedScore >= 6) {
        category = 'Memuaskan';
      } else {
        category = 'Perlu Penambahbaikan';
      }

      return {
        score: `${totalRating}/${totalPossible}`,
        weightedScore: formattedWeightedScore,
        category: category
      };
    },
    isSubmitButtonDisabled() {
      const status = this.status;
      const comment = this.adminComment.trim();
      const submitting = this.isSubmitting;
      const hasVerified = this.criteria.some(c => c.verified);
      return !status || !comment || submitting || !hasVerified;
    },
    categoryOptions() {
      const options = [
        { value: '', text: 'SILA PILIH', disabled: true }
      ];
      if (this.projectCategories && this.projectCategories.length > 0) {
        this.projectCategories.forEach(category => {
          options.push({
            value: category.id.toString(),
            text: category.category_name
          });
        });
      }
      return options;
    },
    hasVerifiedCriteria() {
      return this.criteria.some(c => c.verified);
    },
    computedStatus() {
      const hasRating = this.criteria.some(c => c.rating > 0);

      if (!hasRating) {
        return 'Belum Dinilai';
      }

      // Check if all ratings are 1 star or not rated
      const allOneStarOrNotRated = this.criteria.every(c => c.rating <= 1);

      if (allOneStarOrNotRated) {
        return 'tidak disahkan';
      }

      return this.overallRating.category === 'Perlu Penambahbaikan' ? 'tidak disahkan' : 'disahkan';
    }
  },
  methods: {
    capitalizeName(type) {
      if (type === 'leader') { this.manualLeader.name = this.manualLeader.name.toUpperCase(); } else if (type === 'member') { this.manualMember.name = this.manualMember.name.toUpperCase(); }
    },
    // Dalam methods, tambahkan method ini:
    validateAgeFromNokp(nokp) {
      // Bersihkan nokp dari sebarang karakter bukan nombor
      const cleanNokp = nokp.replace(/\D/g, '');

      if (cleanNokp.length !== 12) {
        return false; // NoKP tidak lengkap
      }

      // Dapatkan tahun lahir dari 2 digit pertama NoKP
      const birthYearDigits = parseInt(cleanNokp.substring(0, 2));
      const currentYear = new Date().getFullYear();
      const currentYearDigits = currentYear % 100; // Dapatkan 2 digit akhir tahun semasa

      // Tentukan abad (tahun 00-23 dianggap 2000-2023, tahun 24-99 dianggap 1924-1999)
      let birthYear;
      if (birthYearDigits <= currentYearDigits) {
        birthYear = 2000 + birthYearDigits;
      } else {
        birthYear = 1900 + birthYearDigits;
      }

      // Kira umur
      const age = currentYear - birthYear;

      // Semak jika umur 17 tahun ke atas
      return age >= 17;
    },
    validateName(event, type) {
      let value = event.target.value;
      // Allow only letters and spaces
      value = value.replace(/[^a-zA-Z\s]/g, '');
      if (type === 'leader') {
        this.manualLeader.name = value;
      } else {
        this.manualMember.name = value;
      }
    },
    validateManualNoKP(event, field) {
      let value = event.target.value.replace(/\D/g, '');
      if (value.length > 12) {
        value = value.substring(0, 12);
      }
      event.target.value = value;

      if (field === 'leader') {
        this.manualLeader.noic = value;
        // Semak umur apabila NoKP lengkap
        if (value.length === 12) {
          if (!this.validateAgeFromNokp(value)) {
            Swal.fire({
              icon: 'warning',
              title: 'Umur Tidak Mencukupi',
              text: 'Hanya individu berumur 17 tahun ke atas dibenarkan sebagai Ketua Pasukan.',
            });
          }
        }
      } else if (field === 'member') {
        this.manualMember.noic = value;
        // Semak umur apabila NoKP lengkap
        if (value.length === 12) {
          if (!this.validateAgeFromNokp(value)) {
            Swal.fire({
              icon: 'warning',
              title: 'Umur Tidak Mencukupi',
              text: 'Hanya individu berumur 17 tahun ke atas dibenarkan sebagai Ahli Pasukan.',
            });
          }
        }
      }
    },
    validateManualPhoneNumber(event) {
      let value = event.target.value;
      value = value.replace(/[^0-9]/g, '');
      if (value.length > 12) {
        value = value.slice(0, 12);
      }
      this.manualLeader.phone = value;
      // Validate phone number format
      if (value && !/^\d{10,12}$/.test(value)) {
        this.phoneErrorMessage = 'Sila masukkan nombor telefon yang sah (10-12 digit)';
      } else {
        this.phoneErrorMessage = '';
      }
    },
    validateManualExtension(event) {
      let value = event.target.value;
      value = value.replace(/[^0-9]/g, '');
      if (value.length > 4) {
        value = value.slice(0, 4);
      }
      this.manualLeader.extension = value;
    },
    addManualLeader() {
      // Semak umur sebelum menambah
      if (this.manualLeader.noic.length === 12 && !this.validateAgeFromNokp(this.manualLeader.noic)) {
        Swal.fire({
          icon: 'warning',
          title: 'Tidak Dibenarkan',
          text: 'Tidak boleh menambah individu di bawah 17 tahun sebagai Ketua Pasukan.',
        });
        return;
      }

      if (this.teamLeaderList.length >= 1) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Hanya satu ketua pasukan dibenarkan.'
        });
        return;
      }

      if (!this.isManualLeaderFormValid) {
        Swal.fire({
          icon: 'warning',
          title: 'Maklumat Tidak Lengkap',
          text: 'Sila lengkapkan semua medan yang diperlukan dengan format yang betul.'
        });
        return;
      }

      this.teamLeaderList.push({
        name: this.manualLeader.name.trim(),
        noic: this.manualLeader.noic,
        email: this.manualLeader.emel.trim(),
        phone: this.manualLeader.phone,
        extension: this.manualLeader.extension || ''
      });

      // Reset form
      this.manualLeader = {
        name: '',
        noic: '',
        emel: '',
        phone: '',
        extension: ''
      };
      this.phoneErrorMessage = '';
      this.$refs.searchModal.hide();
    },

    addManualMember() {
      // Semak umur sebelum menambah
      if (this.manualMember.noic.length === 12 && !this.validateAgeFromNokp(this.manualMember.noic)) {
        Swal.fire({
          icon: 'warning',
          title: 'Tidak Dibenarkan',
          text: 'Tidak boleh menambah individu di bawah 17 tahun sebagai Ahli Pasukan.',
        });
        return;
      }

      if (!this.isManualMemberFormValid) {
        Swal.fire({
          icon: 'warning',
          title: 'Maklumat Tidak Lengkap',
          text: 'Sila lengkapkan semua medan yang diperlukan dengan format yang betul.'
        });
        return;
      }

      this.teamMembersList.push({
        name: this.manualMember.name.trim(),
        noic: this.manualMember.noic,
        email: this.manualMember.emel.trim() || 'Tiada Emel'
      });

      // Reset form
      this.manualMember = {
        name: '',
        noic: '',
        emel: ''
      };
      this.$refs.searchAhliModal.hide();
    },

    getAgencyName(agencyValue) {
      if (!agencyValue) return '';
      const agency = this.agencyOptions.find(opt => opt.value === agencyValue);
      return agency ? agency.text : agencyValue;
    },
    fetchUserIcNumber() {
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData && userData.icNumber) {
        this.userIcNumber = userData.icNumber;
      }
    },
    validateVideoLink(index) {

      const link = this.videoLinks[index];
      if (link.trim() !== '' && !this.validateYouTubeUrl(link)) {
        // Tampilkan pesan error di sebelah input
        this.$set(this.videoLinkErrors, index, 'Hanya pautan YouTube yang diterima');
      } else {
        this.$set(this.videoLinkErrors, index, '');
      }
    },

    // Tambahkan method validasi YouTube URL
    validateYouTubeUrl(url) {
      const patterns = [
        /^(https?:\/\/)?(www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
        /^(https?:\/\/)?(www\.)?youtu\.be\/([a-zA-Z0-9_-]+)/
      ];
      return patterns.some(pattern => pattern.test(url));
    },

    // Method untuk memproses video links sebelum submit

    prepareVideoLinks() {
      return this.videoLinks
        .filter(link => link.trim() !== '')
        .map(link => link.trim())
        .join(',');
    },
    getVideoUrls(videoUrls) {
      if (!videoUrls) return [];
      // Split by comma and clean each URL
      return videoUrls.split(',')
        .map(url => url.trim())
        .filter(url => url !== '');
    },
    addVideoLink() {
      if (this.videoLinks.length < 3) {
        this.videoLinks.push('');
        this.videoLinkErrors.push('');
      }
    },
    removeVideoLink(index) {
      this.videoLinks.splice(index, 1);
      this.videoLinkErrors.splice(index, 1);
    },
    validatePhoneNumber(event) {
      let value = event.target.value;
      // Hanya benarkan nombor dan tanda '+' di awal (untuk nombor antarabangsa)
      value = value.replace(/[^0-9+]/g, '');

      // Jika ada '+' pastikan ia hanya di awal
      if (value.includes('+')) {
        if (value.indexOf('+') !== 0) {
          value = value.replace(/\+/g, '');
          value = '+' + value;
        }
        // Hadkan panjang nombor antarabangsa
        if (value.length > 15) {
          value = value.slice(0, 15);
        }
      } else {
        // Hadkan panjang nombor tempatan
        if (value.length > 12) {
          value = value.slice(0, 12);
        }
      }

      this.searchResultLeader.phone = value;
    },
    // Tambah kaedah baru di sini
    findStateCode(stateValue) {
      if (!stateValue) {
        // console.warn('No state value provided');
        return null;
      }
      const state = this.states.find(s => s.text === stateValue || s.value === stateValue);
      if (!state) {
        // console.error('State not found for:', stateValue);
        return null;
      }
      return state.value;
    },

    findStateName(stateCode) {
      if (!stateCode) return null;
      const state = this.states.find(s => s.value === stateCode);
      return state ? state.text : null;
    },
    resetStarRating(criterion) {
      if (this.project.status === 'disahkan' || this.project.status === 'tidak disahkan') {
        return;
      }
      criterion.rating = 0;
      criterion.hoverRating = 0;
      this.$forceUpdate();
    },
    getRatingCategoryClass(category) {
      switch (category) {
        case 'Cemerlang': return 'text-success';
        case 'Baik': return 'text-primary';
        case 'Sederhana': return 'text-warning';
        case 'Memuaskan': return 'text-orange';
        case 'Perlu Penambahbaikan': return 'text-danger';
        default: return 'text-muted';
      }
    },
    setRating(criterion, star) {
      if (this.project.status === 'disahkan' || this.project.status === 'tidak disahkan') {
        return;
      }
      criterion.rating = star;
      criterion.hoverRating = 0;
      this.$forceUpdate();
    },
    hoverRating(criterion, rating) {
      if (this.project.status === 'disahkan' || this.project.status === 'tidak disahkan') {
        return;
      }
      criterion.hoverRating = rating;
      this.$forceUpdate();
    },
    resetRating(criterion) {
      criterion.hoverRating = 0;
      this.$forceUpdate();
    },
    validateBeforeInfoWordCount() {
      const text = this.beforeInfo;
      const words = text.trim().split(/\s+/).filter(word => word.length > 0);
      const wordCount = words.length;
      this.beforeInfoWordCount = wordCount;
      if (wordCount > 100) {
        this.beforeInfo = words.slice(0, 100).join(' ');
        this.beforeInfoWordCount = 100;
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Had maksimum 100 perkataan telah dicapai.'
        });
      }
    },
    validateAfterInfoWordCount() {
      const text = this.afterInfo;
      const words = text.trim().split(/\s+/).filter(word => word.length > 0);
      const wordCount = words.length;
      this.afterInfoWordCount = wordCount;
      if (wordCount > 100) {
        this.afterInfo = words.slice(0, 100).join(' ');
        this.afterInfoWordCount = 100;
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Had maksimum 100 perkataan telah dicapai.'
        });
      }
    },
    async saveSelectedCriteria() {
      try {
        const projectId = this.$route.params.id;
        const selectedCriteria = this.criteria
          .filter(criterion => criterion.selected)
          .map(criterion => criterion.name);
        const response = await axios.post(baseURL + '/save_project_criteria.php', {
          project_id: projectId,
          criteria: selectedCriteria
        });
        if (response.data.status !== 'success') {
          throw new Error(response.data.message || 'Gagal menyimpan kriteria');
        }
      } catch (error) {
        throw error;
      }
    },
    async saveVerifiedCriteria() {
      try {
        const projectId = this.$route.params.id;
        const verifiedCriteria = this.criteria.filter(c => c.verified).map(c => c.name);
        const response = await axios.post(baseURL + '/save_verified_criteria.php', {
          project_id: projectId,
          verified_criteria: verifiedCriteria
        });
        if (response.data.status !== 'success') {
          throw new Error(response.data.message || 'Gagal menyimpan kriteria yang diverifikasi');
        }
      } catch (error) {
        throw error;
      }
    },
    validateMandatoryFields() {
      const projectName = this.project.name || this.project.project_name;
      if (!projectName || projectName.trim() === '') {
        return 'Sila isi Nama Inisiatif';
      }
      if (!this.project.project_year) {
        return 'Sila pilih Tahun Mula Inisiatif';
      }
      if (
        this.isEditMode && (!this.project.images || this.project.images.length === 0) ||
        (!this.isEditMode && (!this.project.image_url || this.project.image_url.trim() === ''))
      ) {
        return 'Sila muat naik sekurang-kurangnya satu Gambar Inisiatif';
      }
      if (!this.project.category_id) {
        return 'Sila pilih Kategori Inisiatif';
      }
      if (!this.project.ministry) {
        return 'Sila pilih Nama Kementerian';
      }
      if (!this.project.state && !this.project.state_code) {
        return 'Sila pilih Lokasi Inisiatif';
      }
      if (this.isEditMode ? this.teamLeaderList.length === 0 : this.teamLeader.length === 0) {
        return 'Sila tambah sekurang-kurangnya satu Ketua Pasukan';
      }
      if (this.isEditMode ? this.teamMembersList.length === 0 : this.teamMembers.length === 0) {
        return 'Sila tambah sekurang-kurangnya satu Ahli Pasukan';
      }
      if (!this.selectedOutput) {
        return 'Sila pilih Hasil Inisiatif';
      }
      // New mandatory field validations
      if (this.isEditMode && (!this.project.problem || this.project.problem.trim() === '')) {
        return 'Sila isi Penyataan Masalah';
      }
      if (this.isEditMode && (!this.project.proposal_result || this.project.proposal_result.trim() === '')) {
        return 'Sila isi Cadangan Penyelesaian';
      }
      if (this.isEditMode && this.beforeProjectList.length === 0) {
        return 'Sila tambah sekurang-kurangnya satu maklumat Sebelum Pelaksanaan Inisiatif';
      }
      if (this.isEditMode && this.afterProjectList.length === 0) {
        return 'Sila tambah sekurang-kurangnya satu maklumat Selepas Pelaksanaan Inisiatif';
      }
      return null;
    },
    validateCommentWordCount() {
      const text = this.adminComment;
      const words = text.trim().split(/\s+/).filter(word => word.length > 0);
      const wordCount = words.length;
      this.adminCommentWordCount = wordCount;
      if (wordCount > 100) {
        this.adminComment = words.slice(0, 100).join(' ');
        this.adminCommentWordCount = 100;
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Had maksimum 100 perkataan telah dicapai.'
        });
      }
    },
    getOutputName(outputId) {
      if (!outputId) return '';
      const output = this.projectOutputs.find(o => o.id == outputId);
      return output ? output.output_name : 'Tiada hasil inisiatif dipilih';
    },
    async fetchProjectOutputs() {
      try {
        const response = await axios.get(baseURL + '/get_project_outputs.php');
        if (response.data && response.data.status === 'success') {
          this.projectOutputs = response.data.data;
        }
      } catch (error) {
        // console.error('Error fetching project outputs:', error);
      }
    },
    async fetchProjectCategories() {
      try {
        const response = await axios.get(baseURL + '/get_project_categories.php');
        if (response.data && response.data.status === 'success') {
          this.projectCategories = response.data.data;
          if (this.isEditMode && this.project.category_id) {
            this.project.category_id = this.project.category_id.toString();
          }
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Ralat',
          text: 'Gagal memuat data kategori inisiatif'
        });
      }
    },
    generateProjectYears() {
      const currentYear = new Date().getFullYear();
      this.projectYears = ['SILA PILIH'];
      for (let year = 2024; year <= currentYear; year++) {
        this.projectYears.push(year);
      }
    },
    async submitProjectFromViewMode() {
      // Validasi umur untuk ketua pasukan
      const underageLeaders = this.teamLeaderList.filter(
        leader => !this.validateAgeFromNokp(leader.noic)
      );
      if (underageLeaders.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Umur Tidak Mencukupi',
          text: 'Terdapat ketua pasukan yang berumur bawah 17 tahun. Sila betulkan sebelum menghantar.',
        });
        this.tabIndex = 1;
        return;
      }
      // Validasi umur untuk ahli pasukan
      const underageMembers = this.teamMembersList.filter(
        member => !this.validateAgeFromNokp(member.noic)
      );
      if (underageMembers.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Umur Tidak Mencukupi',
          text: 'Terdapat ahli pasukan yang berumur bawah 17 tahun. Sila betulkan sebelum menghantar.',
        });
        this.tabIndex = 1;
        return;
      }
      const validationError = this.validateMandatoryFields();
      if (validationError) {
        Swal.fire({
          icon: 'error',
          title: 'Maklumat Tidak Lengkap',
          text: validationError,
        });
        return;
      }

      if (this.isSubmitting) return;
      const result = await Swal.fire({
        icon: 'question',
        title: 'Hantar Inisiatif',
        text: 'Adakah anda pasti ingin menghantar inisiatif ini?',
        showCancelButton: true,
        confirmButtonText: 'Ya, Hantar',
        cancelButtonText: 'Batal',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      });
      if (!result.isConfirmed) return;

      try {
        this.isSubmitting = true;
        await this.saveSelectedCriteria();
        const formData = new FormData();
        formData.append('id', this.$route.params.id);
        formData.append('name', this.project.project_name || '');
        formData.append('description', this.project.description || '');
        formData.append('proposal_result', this.project.proposal_result || '');
        formData.append('problem', this.project.problem || '');
        formData.append('video_link', this.project.video_url || '');
        formData.append('ministry', this.project.ministry || '');
        formData.append('agency', this.project.department || 'aaaaa');
        // formData.append('state', this.project.state || null);
        formData.append('state_code', this.project.state ? this.findStateCode(this.project.state) : null);
        formData.append('project_year', this.project.project_year || '');
        formData.append('category_id', this.project.category_id || '');
        formData.append('team_leader', JSON.stringify(this.teamLeaderList.map(leader => ({
          name: leader.name,
          noic: leader.noic,
          email: leader.email,
          phone: leader.phone,
          extension: leader.extension
        }))));
        formData.append('team_members', JSON.stringify(this.teamMembersList));
        formData.append('before_project', JSON.stringify(this.beforeProjectImpacts));
        formData.append('after_project', JSON.stringify(this.afterProjectImpacts));
        formData.append('testimoni', this.project.testimoni || '');
        formData.append('project_cost', this.project.project_cost || '0');
        formData.append('criteria', JSON.stringify(this.criteria.map(c => ({
          name: c.name,
          selected: c.selected,
          verified: c.verified
        }))));
        formData.append('action', 'baru');
        formData.append('outputs', JSON.stringify(this.selectedOutput ? [this.selectedOutput] : []));
        if (this.project.slide_url) {
          formData.append('existing_slide_url', this.project.slide_url);
        }
        const existingImages = this.project.image_url ? this.getImageUrls(this.project.image_url) : [];
        formData.append('existing_images', JSON.stringify(existingImages));
        const existingTestimoniImages = this.project.testimoni_image_url ? this.getImageUrls(this.project.testimoni_image_url) : [];
        formData.append('existing_testimoni_images', JSON.stringify(existingTestimoniImages));

        const response = await axios.post(baseURL + '/kemaskini_view_projek.php', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.data.status === 'success') {
          Swal.fire({
            icon: 'success',
            title: 'Inisiatif Berjaya Dihantar!',
            showConfirmButton: false,
            timer: 1500,
          });
          this.fetchProjectDetails();
          this.$router.push('/senarai-projek');
        } else {
          throw new Error(response.data.message || 'Gagal menghantar inisiatif');
        }
      } catch (error) {
        // console.error('Error submitting project:', error);
        let errorMessage = 'Terdapat ralat semasa menghantar inisiatif.';
        if (error.response) {
          errorMessage = error.response.data.message || `Ralat dari server: ${error.response.status}`;
        } else if (error.request) {
          errorMessage = 'Tiada sambungan ke server. Sila semak sambungan internet anda.';
        } else {
          errorMessage = `Ralat: ${error.message}`;
        }
        Swal.fire({
          icon: 'error',
          title: 'Ralat!',
          text: errorMessage,
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    async updateVerification(criterion, isVerified) {
      criterion._loading = true;
      if (this.project.status === 'disahkan' || this.project.status === 'tidak disahkan') {
        Swal.fire({
          icon: 'warning',
          title: 'Tidak Dibenarkan',
          text: 'Pengesahan kriteria tidak boleh diubah kerana inisiatif telah disahkan atau tidak disahkan.',
        });
        this.$nextTick(() => {
          criterion.verified = !isVerified;
          criterion._loading = false;
        });
        return;
      }
      try {
        criterion.verified = isVerified;
        const projectId = this.$route.params.id;
        const response = await axios.post(baseURL + '/update_criterion_verification.php', {
          project_id: projectId,
          criterion_name: criterion.name,
          admin_approved: isVerified ? 1 : 0,
          rating: criterion.rating || 0
        });
        if (response.data.status !== 'success') {
          throw new Error(response.data.message || 'Failed to update criterion verification');
        }
      } catch (error) {
        this.$nextTick(() => {
          criterion.verified = !isVerified;
          criterion._loading = false;
        });
        Swal.fire({
          icon: 'error',
          title: 'Ralat!',
          text: 'Terdapat ralat semasa mengemaskini status pengesahan.',
        });
      } finally {
        criterion._loading = false;
      }
    },
    validateProjectCost() {
      if (!this.projectCostInput) {
        this.projectCostInput = '0.00';
        this.project.project_cost = '0.00';
        this.formattedProjectCost = 'RM 0.00';
        return;
      }
      const num = parseFloat(this.projectCostInput);
      if (isNaN(num)) {
        this.projectCostInput = '0.00';
        this.project.project_cost = '0.00';
        this.formattedProjectCost = 'RM 0.00';
      } else {
        this.projectCostInput = num.toFixed(2);
        this.project.project_cost = this.projectCostInput;
        this.formattedProjectCost = this.formatCurrency(this.projectCostInput);
      }
    },
    triggerTestimoniFileInput() {
      this.$refs.testimoniFileInput.click();
    },
    onTestimoniDrop(event) {
      event.preventDefault();
      this.isDragging = false;
      const files = event.dataTransfer.files;
      this.handleTestimoniFiles(files);
    },
    handleTestimoniUpload(event) {
      const files = event.target.files;
      this.handleTestimoniFiles(files);
    },
    handleTestimoniFiles(files) {
      if (!files) return;
      if (!this.project.testimoni_images) {
        this.project.testimoni_images = [];
      }
      if (this.project.testimoni_images.length + files.length > 3) {
        this.errorMessage = 'Maksimum 3 gambar testimoni dibenarkan.';
        Swal.fire({
          icon: 'error',
          title: 'Ralat',
          text: this.errorMessage,
        });
        return;
      }
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      Array.from(files).forEach(file => {
        if (!allowedTypes.includes(file.type)) {
          this.errorMessage = 'Format fail tidak sah. Hanya jpg, jpeg, dan png dibenarkan.';
          Swal.fire({
            icon: 'error',
            title: 'Ralat',
            text: this.errorMessage,
          });
          return;
        }
        if (file.size > 2 * 1024 * 1024) {
          this.errorMessage = 'Saiz fail melebihi 2MB. Sila pilih fail lain.';
          Swal.fire({
            icon: 'error',
            title: 'Ralat',
            text: this.errorMessage,
          });
          return;
        }
        this.project.testimoni_images.push(file);
      });
    },
    removeTestimoniImage(index) {
      if (this.project.testimoni_images[index].url) {
        if (!this.project.testimoniImagesToDelete) {
          this.project.testimoniImagesToDelete = [];
        }
        this.project.testimoniImagesToDelete.push(this.project.testimoni_images[index].url);
      }
      this.project.testimoni_images.splice(index, 1);
    },
    getPdfFileName(pdfPath) {
      if (!pdfPath) return '';
      if (typeof pdfPath === 'string') {
        return pdfPath.split('/').pop();
      } else if (pdfPath instanceof File) {
        return pdfPath.name;
      }
      return 'Slaid PDF';
    },
    getPdfUrl(pdfPath) {
      if (!pdfPath) return '';

      // 1. Normalisasi path (ganti backslash dengan forward slash)
      const normalizedPath = pdfPath.replace(/\\/g, '/');

      // 2. Hapus 'uploads/' jika ada duplikasi
      const cleanPath = normalizedPath.replace(/^uploads\//, '');

      // 3. Bangun URL lengkap
      const fullUrl = `${baseURLProjectPdf}/uploads/${cleanPath}`;

      return fullUrl;
    },
    getBaseUrl() {
      // Sesuaikan dengan environment Anda
      return window.location.origin + '/hemat-api';
      // Atau jika menggunakan port tertentu:
      // return 'http://localhost:8000';
    },

    triggerPdfInput() {
      this.$refs.pdfInput.click();
    },
    onPdfDrop(event) {
      event.preventDefault();
      this.isDragging = false;
      const files = event.dataTransfer.files;
      this.handlePdfFiles(files);
    },
    handlePdfUpload(event) {
      const files = event.target.files;
      this.handlePdfFiles(files);
    },
    handlePdfFiles(files) {
      if (files && files.length > 0) {
        const file = files[0];
        if (file.type !== 'application/pdf') {
          Swal.fire({
            icon: 'error',
            title: 'Ralat',
            text: 'Hanya fail PDF dibenarkan.',
          });
          return;
        }
        if (file.size > 5 * 1024 * 1024) {
          Swal.fire({
            icon: 'error',
            title: 'Ralat',
            text: 'Saiz fail melebihi 5MB. Sila pilih fail lain.',
          });
          return;
        }
        if (typeof this.project.slide_url === 'string') {
          this.project.slideToDelete = this.project.slide_url;
        }
        this.project.slide_url = file;
      }
    },
    removePdf() {
      if (typeof this.project.slide_url === 'string') {
        this.project.slideToDelete = this.project.slide_url;
      }
      this.project.slide_url = null;
    },
    checkUserRole() {
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData && userData.peranan === 'admin') {
        this.isAdmin = true;
      } else {
        this.isAdmin = false;
      }
    },
    async submitApproval() {
      // Check if all criteria have been rated
      const unratedCriteria = this.criteria.some(c => c.rating === 0);
      if (unratedCriteria) {
        Swal.fire({
          icon: 'warning',
          title: 'Penilaian Tidak Lengkap!',
          text: 'Sila berikan rating untuk semua kriteria H.E.M.A.T. sebelum mengemukakan penilaian.',
          confirmButtonColor: '#3085d6',
        });
        return;
      }

      // Check if all ratings are 1 star
      const allOneStar = this.criteria.every(c => c.rating <= 1);
      const status = allOneStar ? 'tidak disahkan' : 'disahkan';

      // Validate admin comment if status is 'tidak disahkan'
      if (status === 'tidak disahkan' && (!this.adminComment || this.adminComment.trim() === '')) {
        Swal.fire({
          icon: 'warning',
          title: 'Ulasan Diperlukan!',
          text: 'Sila masukkan ulasan untuk inisiatif yang tidak Memenuhi.',
          confirmButtonColor: '#3085d6',
        });
        return;
      }

      try {
        this.isSubmitting = true;

        // Prepare criteria data with ratings
        const criteriaData = this.criteria.map(criterion => ({
          name: criterion.name,
          rating: criterion.rating,
          admin_approved: criterion.rating >= 3 ? 1 : 0,
        }));

        const projectId = this.$route.params.id;
        const userData = JSON.parse(localStorage.getItem('user'));
        if (!userData || !userData.id) {
          Swal.fire({
            icon: 'error',
            title: 'Ralat!',
            text: 'Maklumat pengguna tidak dijumpai. Sila log masuk semula.',
          });
          return;
        }
        const userId = userData.id;

        // Send all criteria ratings and approval status to the server
        const response = await axios.post(baseURL + '/kemaskini_status.php', {
          id: projectId,
          status: status,
          comment: this.adminComment,
          approve_id: userId,
          weighted_score: this.overallRating.weightedScore,
          rating_category: this.overallRating.category,
          criteria: criteriaData,
        });

        if (response.data.status === 'success') {
          // Update ratings in the database for each criterion
          for (const criterion of criteriaData) {
            await axios.post(baseURL + '/update_criterion_verification.php', {
              project_id: projectId,
              criterion_name: criterion.name,
              admin_approved: criterion.admin_approved,
              rating: criterion.rating,
            });
          }

          Swal.fire({
            icon: 'success',
            title: 'Berjaya!',
            text: 'Status, ulasan, dan rating berjaya dikemaskini!',
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            this.fetchProjectDetails();
            this.fetchCriteriaLockup();
            this.$router.push('/senarai-projek');
          });
        } else {
          throw new Error(response.data.message || 'Gagal mengemaskini status');
        }
      } catch (error) {
        // console.error('Error submitting approval:', error);
        Swal.fire({
          icon: 'error',
          title: 'Ralat!',
          text: 'Terdapat ralat semasa mengemaskini status: ' + ((error.response && error.response.data && error.response.data.message) || error.message),
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    cancelEditMode() {
      this.isEditMode = false;
      this.project.imagesToDelete = [];
      this.project.testimoniImagesToDelete = [];
      this.project.slideToDelete = null;
      this.fetchProjectDetails();
      this.fetchTeamDetails();
      this.fetchCriteriaLockup();
      this.fetchProjectImpacts();
    },
    toggleEditMode() {
      this.isEditMode = !this.isEditMode;
      if (this.isEditMode) {
        this.project = {
          ...this.project,
          category_id: this.project.category_id ? this.project.category_id.toString() : '',
          name: this.project.project_name,
          images: this.project.image_url ? this.getImageUrls(this.project.image_url).map(url => ({ name: url.split('/').pop(), url })) : [],
          video_link: this.project.video_url,
          testimoni_images: this.project.testimoni_image_url ? this.getImageUrls(this.project.testimoni_image_url).map(url => ({ name: url.split('/').pop(), url })) : [],
          agency: this.project.buid_agensi || this.project.department || 'sasasa',
          state: this.project.state_code || this.project.state || null,
          slide_url: this.project.slide_url || null,
        };

        // Inisialisasi videoLinks berdasarkan video_url yang ada
        this.videoLinks = this.project.video_url
          ? this.getVideoUrls(this.project.video_url)
          : ['']; // Default array dengan 1 string kosong

        // Muat senarai agensi berdasarkan kementerian semasa
        if (this.project.ministry) {
          this.fetchAgencies(this.project.ministry);
        } else {
          this.agencyOptions = [{ value: null, text: 'SILA PILIH ORGANISASI TERLEBIH DAHULU' }];
          this.project.agency = null;
        }

        this.teamLeaderList = this.teamLeader.map(leader => ({
          name: leader.member_name,
          noic: leader.member_icno,
          email: leader.email,
          phone: leader.phone,
          extension: leader.extension
        }));

        this.teamMembersList = this.teamMembers.map(member => ({
          name: member.member_name,
          noic: member.member_icno
        }));

        this.beforeProjectList = [...this.beforeProjectImpacts];
        this.afterProjectList = [...this.afterProjectImpacts];

        this.criteria = this.criteria.map(criterion => ({
          ...criterion,
          selected: this.selectedCriteria.includes(criterion.name)
        }));

        this.projectCostInput = this.project.project_cost || '';
      } else {
        this.fetchProjectDetails();
      }
    },
    updateProjectCost(event) {
      const value = event.target.value;
      let cleanedValue = value.replace(/[^0-9.]/g, '');
      const parts = cleanedValue.split('.');
      if (parts.length > 2) {
        cleanedValue = parts[0] + '.' + parts.slice(1).join('');
      }
      if (parts[1] && parts[1].length > 2) {
        cleanedValue = parts[0] + '.' + parts[1].slice(0, 2);
      }
      this.projectCostInput = cleanedValue;
      this.project.project_cost = cleanedValue;
      this.formattedProjectCost = this.formatCurrency(cleanedValue);
    },
    findAgencyId(agencyName) {
      const agency = this.agencies.find(a => a.text === agencyName);
      return agency ? agency.value : '';
    },
    findStateId(stateName) {
      const state = this.states.find(s => s.text === stateName);
      return state ? state.value : '';
    },
    async fetchProjectDetails() {
      try {
        const projectId = this.$route.params.id;
        const userData = JSON.parse(localStorage.getItem('user'));
        const userId = userData ? userData.id : null;
        const icNumber = userData ? userData.icNumber : null;
        const buidagensi = userData ? userData.buidagensi : null;
        const peranan = userData ? userData.peranan : null;
        const response = await axios.get(
          `${baseURL}/papar_projek_id.php?id=${projectId}&userId=${userId}&icNumber=${icNumber}&buidagensi=${buidagensi}&peranan=${peranan}`
        );

        if (response.data && response.data.status !== 'error') {
          this.adminComment = response.data[0].comment || '';
          this.project = response.data[0];

          // Initialize video links
          if (this.project.video_url) {
            this.videoLinks = this.getVideoUrls(this.project.video_url);
          } else {
            this.videoLinks = [''];
          }

          this.project.state = response.data[0].state_code || response.data[0].state || null;
          this.project.state_name = this.findStateName(response.data[0].state_code || response.data[0].state);
          this.project.category_id = response.data[0].category_id || '';
          this.project.project_year = response.data[0].project_year || '';
          this.project.agency = response.data[0].buid_agensi || response.data[0].department || 'mamama';
          // console.log('Project agency set:', this.project.agency);
          // Fetch agencies for the selected ministry
          if (this.project.ministry) {
            await this.fetchAgencies(this.project.ministry);
          } else {
            this.agencyOptions = [{ value: null, text: 'SILA PILIH ORGANISASI TERLEBIH DAHULU' }];
          }
          this.adminComment = response.data[0].comment || '';
          this.status = response.data[0].status || '';
          this.selectedOutput = response.data[0].output_name ? parseInt(response.data[0].output_name) : null;
          this.project.images = this.project.image_url
            ? this.getImageUrls(this.project.image_url).map(url => ({ name: url.split('/').pop(), url }))
            : [];
          this.project.testimoni_images = this.project.testimoni_image_url
            ? this.getImageUrls(this.project.testimoni_image_url).map(url => ({ name: url.split('/').pop(), url }))
            : [];
          if (this.projectCategories.length > 0) {
            const category = this.projectCategories.find(cat => cat.id == this.project.category_id);
            this.project.category_name = category ? category.category_name : 'Tiada maklumat kategori';
          }
          this.project.project_cost = response.data[0].project_cost || '';
          this.projectCostInput = this.project.project_cost;
          this.formattedProjectCost = this.formatCurrency(this.project.project_cost);
          this.status = response.data[0].status || '';
        }
      } catch (error) {
        // console.error('Error fetching project details:', error);
      }
    },
    async fetchTeamDetails() {
      try {
        const projectId = this.$route.params.id;
        const response = await axios.get(baseURL + `/get_project_team_members.php?project_id=${projectId}`);
        if (response.data && response.data.status === "success") {
          const teamData = response.data.data;
          this.teamLeader = teamData.filter(member => member.no_turutan === "1" || member.no_turutan === 1).map(leader => ({
            member_name: leader.member_name,
            member_icno: leader.member_icno,
            email: leader.email || 'Tiada Emel',
            phone: leader.phone || '',
            extension: leader.extension || '',
            role: leader.role || 'Jawatan Tidak Dinyatakan'
          }));
          this.teamMembers = teamData.filter(member => member.no_turutan !== "1" && member.no_turutan !== 1).map(member => ({
            member_name: member.member_name,
            member_icno: member.member_icno,
            role: member.role || 'Jawatan Tidak Dinyatakan'
          }));
          this.teamLeaderList = this.teamLeader.map(leader => ({
            name: leader.member_name,
            noic: leader.member_icno,
            email: leader.email,
            phone: leader.phone,
            extension: leader.extension
          }));
          this.teamMembersList = this.teamMembers.map(member => ({
            name: member.member_name,
            noic: member.member_icno
          }));
        }
      } catch (error) {
        // console.error('Error fetching team details:', error);
      }
    },
    validateNoKP(event) {
      let value = event.target.value.replace(/\D/g, '');
      if (value.length > 12) {
        value = value.substring(0, 12);
      }
      event.target.value = value;
      this.searchNoKP = value;
      this.searchNoKPMember = value;

      // Semak umur apabila NoKP lengkap
      if (value.length === 12) {
        if (!this.validateAgeFromNokp(value)) {
          Swal.fire({
            icon: 'warning',
            title: 'Umur Tidak Mencukupi',
            text: 'Hanya individu berumur 17 tahun ke atas dibenarkan.',
          });
        }
      }
    },
    validateExtension(event) {
      let value = event.target.value;
      value = value.replace(/[^0-9]/g, '');
      if (value.length > 6) {
        value = value.slice(0, 6);
      }
      this.searchResultLeader.extension = value;
    },
    async fetchCriteriaLockup() {
      try {
        const projectId = this.$route.params.id;
        const response = await axios.get(baseURL + `/get_project_criteria.php?project_id=${projectId}`);
        if (response.data && response.data.status === "success") {
          this.criteria = this.criteria.map(criterion => {
            const dbCriterion = response.data.data.find(c => c.criterion_name === criterion.name);
            return {
              ...criterion,
              user_selection: dbCriterion ? dbCriterion.user_selection === "1" || dbCriterion.user_selection === 1 : false,
              admin_approved: dbCriterion ? dbCriterion.admin_approved === "1" || dbCriterion.admin_approved === 1 : false,
              rating: dbCriterion && dbCriterion.score !== null ? parseInt(dbCriterion.score) : 0,
              hoverRating: 0
            };
          });

          this.selectedCriteria = this.criteria
            .filter(criterion => criterion.user_selection)
            .map(criterion => criterion.name);

          // console.log('Criteria after mapping:', this.criteria.map(c => ({
          //   name: c.name,
          //   user_selection: c.user_selection,
          //   admin_approved: c.admin_approved,
          //   rating: c.rating
          // })));
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Ralat!',
            text: 'Gagal memuat data kriteria.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Ralat!',
          text: 'Gagal memuat data kriteria.',
        });
      }
    },
    async fetchProjectImpacts() {
      try {
        const projectId = this.$route.params.id;
        const response = await axios.get(baseURL + `/get_project_impacts.php?project_id=${projectId}`);
        if (response.data && response.data.status === "success") {
          this.beforeProjectImpacts = response.data.data.empty_before_project.map(item => item.before_project);
          this.afterProjectImpacts = response.data.data.empty_after_project.map(item => item.after_project);
        }
      } catch (error) {
        // console.error('Error fetching project impacts:', error);
      }
    },
    async fetchMinistries() {
      try {
        const response = await axios.get(baseURL + '/get_ministries.php');
        if (response.data && response.data.status === 'success') {
          this.ministries = response.data.data.map(ministry => ({
            value: ministry.id,
            text: ministry.nama_kementerian,
          }));
        }
      } catch (error) {
        // console.error('Error fetching ministries:', error);
      }
    },
    async fetchAgencies(buidKementerian) {
      try {
        const userData = JSON.parse(localStorage.getItem('user'));
        // const userId = userData ? userData.id : null;
        const icNumber = userData ? userData.icNumber : null;
        const buid_awam = userData ? userData.buidagensi : null;
        this.agencyOptions = [{ value: null, text: 'SILA PILIH' }]; // Opsyen SILA PILIH tanpa disabled
        if (!buidKementerian) {
          this.project.agency = null; // Kosongkan agensi jika tiada kementerian
          // console.log('Agency options (no ministry):', this.agencyOptions);
          return;
        }
        // console.log('Fetching agencies for ministry:', buidKementerian);
        const response = await axios.get(`${baseURL}/get_agencies_view.php?buid_kementerian=${buidKementerian}&icNumber=${icNumber}&buid_awam=${buid_awam}`);
        // console.log('API response:', response.data);
        if (response.data && response.data.status === 'success') {
          if (response.data.data.length === 0) {
            this.agencyOptions = [{ value: null, text: 'Tiada agensi tersedia untuk organisasi ini' }];
          } else {
            this.agencyOptions = [
              { value: null, text: 'SILA PILIH' },
              ...response.data.data.map(agency => ({
                value: agency.buid_agensi,
                text: agency.nama_agensi
              }))
            ];
          }
          // Jika agensi semasa tidak wujud dalam senarai baru, kosongkan
          if (this.project.agency && !this.agencyOptions.find(opt => opt.value === this.project.agency)) {
            this.project.agency = null;
          }
          // console.log('Agency options set:', this.agencyOptions);
        } else {
          this.agencyOptions = [{ value: null, text: 'Tiada agensi dijumpai' }];
          this.project.agency = null;
          // console.log('Agency options (no agencies found):', this.agencyOptions);
        }
      } catch (error) {
        // console.error('Error fetching agencies:', error);
        this.agencyOptions = [{ value: null, text: 'Ralat memuat agensi' }];
        this.project.agency = null;
        // console.log('Agency options (error):', this.agencyOptions);
      }
    },
    async fetchStates() {
      try {
        const response = await axios.get(baseURL + '/get_states.php');
        // console.log('Fetched states:', response.data);
        if (response.data && response.data.status === 'success') {
          this.states = [
            { value: null, text: 'SILA PILIH', disabled: true }, // Tambahkan opsi default
            ...response.data.data.map(state => ({
              value: state.state_code, // e.g., 'JHR'
              text: state.state_name   // e.g., 'Johor'
            }))
          ];
        }
      } catch (error) {
        // console.error('Error fetching states:', error);
      }
    },
    countWords(text) {
      if (!text) return 0;
      const words = text.trim().split(/\s+/).filter(word => word.length > 0);
      return words.length;
    },
    validateWordCount(field) {
      const text = this.project[field];
      const words = text.trim().split(/\s+/).filter(word => word.length > 0);
      const wordCount = this.countWords(text);
      if (field === 'problem') this.problemWordCount = wordCount;
      else if (field === 'testimoni') this.testimoniWordCount = wordCount;
      else if (field === 'proposal_result') this.proposalResultWordCount = wordCount;
      if (wordCount > 100) {
        this.project[field] = words.slice(0, 100).join(' ');
        if (field === 'problem') this.problemWordCount = 100;
        else if (field === 'testimoni') this.testimoniWordCount = 100;
        else if (field === 'proposal_result') this.proposalResultWordCount = 100;
        Swal.fire({ icon: 'warning', title: 'Peringatan', text: 'Had maksimum 100 perkataan telah dicapai.' });
      }
    },
    formatCurrency(value) {
      if (!value || isNaN(value)) return 'RM 0.00';
      const numValue = parseFloat(value);
      return new Intl.NumberFormat('ms-MY', {
        style: 'currency',
        currency: 'MYR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numValue);
    },
    handleSubmit(event) {
      event.preventDefault();
    },
    removeImage(index) {
      if (this.project.images[index].url) {
        if (!this.project.imagesToDelete) {
          this.project.imagesToDelete = [];
        }
        this.project.imagesToDelete.push(this.project.images[index].url);
      }
      this.project.images.splice(index, 1);
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onDragOver(event) {
      event.preventDefault();
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    onDrop(event) {
      event.preventDefault();
      this.isDragging = false;
      const files = event.dataTransfer.files;
      this.handleFiles(files);
    },
    handleImageUpload(event) {
      const files = event.target.files;
      this.handleFiles(files);
    },
    handleFiles(files) {
      if (!files) return;
      if (!this.project.images) {
        this.project.images = [];
      }
      if (this.project.images.length + files.length > 3) {
        this.errorMessage = 'Maksimum 3 gambar dibenarkan.';
        Swal.fire({
          icon: 'error',
          title: 'Ralat',
          text: this.errorMessage,
        });
        return;
      }
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      Array.from(files).forEach(file => {
        if (!allowedTypes.includes(file.type)) {
          this.errorMessage = 'Format fail tidak sah. Hanya jpg, jpeg, dan png dibenarkan.';
          Swal.fire({
            icon: 'error',
            title: 'Ralat',
            text: this.errorMessage,
          });
          return;
        }
        if (file.size > 2 * 1024 * 1024) {
          this.errorMessage = 'Saiz fail melebihi 2MB. Sila pilih fail lain.';
          Swal.fire({
            icon: 'error',
            title: 'Ralat',
            text: this.errorMessage,
          });
          return;
        }
        this.project.images.push(file);
      });
    },
    nextTab() {
      if (this.tabIndex < 3) this.tabIndex++;
    },
    prevTab() {
      if (this.tabIndex > 0) this.tabIndex--;
    },
    showSearchModal() {
      this.searchNoKP = '';
      this.searchResultLeader = null;
      this.manualLeader = {
        name: '',
        noic: '',
        emel: '',
        phone: '',
        extension: ''
      };
      this.phoneErrorMessage = '';
      this.$refs.searchModal.show();
    },
    showSearchAhliModal() {
      this.searchNoKPMember = '';
      this.searchResultMember = null;
      this.manualMember = {
        name: '',
        noic: '',
        emel: ''
      };
      this.$refs.searchAhliModal.show();
    },
    async searchTeamLeader() {
      // Semak umur sebelum membuat carian
      const userData = JSON.parse(localStorage.getItem('user')) || {};
      const currentUserIcno = userData.icno ? userData.icno : '';
      if (this.searchNoKP.length === 12 && !this.validateAgeFromNokp(this.searchNoKP)) {
        Swal.fire({
          icon: 'warning',
          title: 'Tidak Dibenarkan',
          text: 'Tidak boleh mencari individu di bawah 17 tahun.',
        });
        return;
      }

      try {
        const response = await axios.get(baseURL + `/search_team_leader.php?nokp=${this.searchNoKP}&current_user=${currentUserIcno}`);
        if (response.data && response.data.status === 'success') {
          this.searchResultLeader = response.data.data;

          // Semak umur sekali lagi untuk data yang diterima
          if (!this.validateAgeFromNokp(this.searchResultLeader.nokp)) {
            Swal.fire({
              icon: 'warning',
              title: 'Umur Tidak Mencukupi',
              text: 'Individu yang dicari tidak memenuhi syarat umur (17 tahun ke atas).',
            });
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Maaf!',
            text: 'Tiada rekod ditemui.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Maaf!',
          text: 'Terdapat ralat semasa carian.',
        });
      }
    },

    async searchTeamMember() {

      const userData = JSON.parse(localStorage.getItem('user')) || {};
      const currentUserIcno = userData.icno ? userData.icno : '';
      // Semak umur sebelum membuat carian
      if (this.searchNoKPMember.length === 12 && !this.validateAgeFromNokp(this.searchNoKPMember)) {
        Swal.fire({
          icon: 'warning',
          title: 'Tidak Dibenarkan',
          text: 'Tidak boleh mencari individu di bawah 17 tahun.',
        });
        return;
      }

      try {
        const response = await axios.get(baseURL + `/search_team_leader.php?nokp=${this.searchNoKPMember}&current_user=${currentUserIcno}`);
        if (response.data && response.data.status === 'success') {
          this.searchResultMember = response.data.data;

          // Semak umur sekali lagi untuk data yang diterima
          if (!this.validateAgeFromNokp(this.searchResultMember.nokp)) {
            Swal.fire({
              icon: 'warning',
              title: 'Umur Tidak Mencukupi',
              text: 'Individu yang dicari tidak memenuhi syarat umur (17 tahun ke atas).',
            });
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Maaf!',
            text: 'Tiada rekod ditemui.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Terdapat ralat semasa carian.',
        });
      }
    },
    selectTeamLeader() {
      if (this.searchResultLeader) {
        // Semak umur sebelum menambah
        if (!this.validateAgeFromNokp(this.searchResultLeader.nokp)) {
          Swal.fire({
            icon: 'warning',
            title: 'Tidak Dibenarkan',
            text: 'Tidak boleh menambah individu di bawah 17 tahun sebagai Ketua Pasukan.',
          });
          return;
        }

        // Semak jika nombor telefon kosong
        if (!this.searchResultLeader.phone || this.searchResultLeader.phone.trim() === '') {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'No Telefon adalah mandatori. Sila masukkan nombor telefon.',
          });
          return;
        }

        if (this.teamLeaderList.length >= 1) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Hanya satu ketua pasukan dibenarkan. Padam ketua sedia ada untuk menambah yang baru.',
          });
          return;
        }

        const newLeader = {
          name: this.searchResultLeader.name,
          noic: this.searchResultLeader.nokp,
          email: this.searchResultLeader.emel,
          phone: this.searchResultLeader.phone,
          extension: this.searchResultLeader.extension,
        };
        this.teamLeaderList.push(newLeader);
        this.searchResultLeader = null;
        this.searchNoKP = '';
        this.$refs.searchModal.hide();
      }
    },

    removeTeamLeader(index) {
      this.teamLeaderList.splice(index, 1);
    },
    selectTeamMember() {
      if (this.searchResultMember) {
        // Semak umur sebelum menambah
        if (!this.validateAgeFromNokp(this.searchResultMember.nokp)) {
          Swal.fire({
            icon: 'warning',
            title: 'Tidak Dibenarkan',
            text: 'Tidak boleh menambah individu di bawah 17 tahun sebagai Ahli Pasukan.',
          });
          return;
        }

        const newMember = {
          name: this.searchResultMember.name,
          noic: this.searchResultMember.nokp,
          email: this.searchResultMember.emel || '',
        };
        this.teamMembersList.push(newMember);
        this.searchResultMember = null;
        this.searchNoKPMember = '';
        this.$refs.searchAhliModal.hide();
      }
    },
    removeTeamMember(index) {
      this.teamMembersList.splice(index, 1);
    },
    showBeforeModal() {
      this.beforeInfo = '';
      this.$refs.beforeModal.show();
    },
    showAfterModal() {
      this.afterInfo = '';
      this.$refs.afterModal.show();
    },
    addBeforeInfo() {
      if (this.beforeInfo.trim()) {
        if (this.beforeInfoWordCount > 100) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Had maksimum 100 perkataan telah dicapai.'
          });
          return;
        }
        this.beforeProjectList.push(this.beforeInfo.trim());
        this.$refs.beforeModal.hide();
      } else {
        Swal.fire({ icon: 'warning', title: 'Peringatan', text: 'Sila masukkan maklumat sebelum menambah.' });
      }
    },
    removeBeforeItem(index) {
      this.beforeProjectList.splice(index, 1);
    },
    addAfterInfo() {
      if (this.afterInfo.trim()) {
        if (this.afterInfoWordCount > 100) {
          Swal.fire({
            icon: 'warning',
            title: 'Peringatan',
            text: 'Had maksimum 100 perkataan telah dicapai.'
          });
          return;
        }
        this.afterProjectList.push(this.afterInfo.trim());
        this.$refs.afterModal.hide();
      } else {
        Swal.fire({ icon: 'warning', title: 'Peringatan', text: 'Sila masukkan maklumat sebelum menambah.' });
      }
    },
    removeAfterItem(index) {
      this.afterProjectList.splice(index, 1);
    },
    getImageUrls(imagePaths) {
      if (!imagePaths) return [];

      return imagePaths.split(',').map(path => {
        const cleanPath = path.trim();
        // Ganti backslash dengan forward slash jika ada
        const normalizedPath = cleanPath.replace(/\\/g, '/');
        // Hapus 'uploads/' jika ada duplikasi
        const cleanImagePath = normalizedPath.replace(/^uploads\//, '');

        // Bangun URL lengkap
        const fullUrl = `${baseURLProjectPdf}/uploads/${cleanImagePath}`;

        // console.log('Generated Image URL:', {
        //   originalPath: path,
        //   normalizedPath,
        //   cleanImagePath,
        //   fullUrl
        // });

        return fullUrl;
      });
    },
    getEmbedUrl(videoUrl) {
      if (!videoUrl) return '';

      // Handle YouTube URL formats
      let videoId = videoUrl;

      if (videoUrl.includes('youtube.com')) {
        const parts = videoUrl.split('v=');
        if (parts.length > 1) {
          const params = parts[1].split('&');
          videoId = params[0];
        }
      } else if (videoUrl.includes('youtu.be')) {
        const parts = videoUrl.split('youtu.be/');
        if (parts.length > 1) {
          const params = parts[1].split('?');
          videoId = params[0];
        }
      }

      return `https://www.youtube.com/embed/${videoId}`;
    },
    async submitProject(action) {
      // Validasi umur untuk ketua pasukan
      const underageLeaders = this.teamLeaderList.filter(
        leader => !this.validateAgeFromNokp(leader.noic)
      );
      if (underageLeaders.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Umur Tidak Mencukupi',
          text: 'Terdapat ketua pasukan yang berumur bawah 17 tahun. Sila betulkan sebelum menghantar.',
        });
        this.tabIndex = 1;
        return;
      }

      // Validasi umur untuk ahli pasukan
      const underageMembers = this.teamMembersList.filter(
        member => !this.validateAgeFromNokp(member.noic)
      );
      if (underageMembers.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Umur Tidak Mencukupi',
          text: 'Terdapat ahli pasukan yang berumur bawah 17 tahun. Sila betulkan sebelum menghantar.',
        });
        this.tabIndex = 1;
        return;
      }
      // console.log('Selected state:', this.project.state);
      // console.log('State code:', this.findStateCode(this.project.state));
      const invalidLinks = this.videoLinks
        .filter(link => link.trim() !== '')
        .some(link => !this.validateYouTubeUrl(link));

      if (invalidLinks) {
        Swal.fire('Error', 'Hanya pautan YouTube yang diterima', 'error');
        return;
      }
      if (this.teamLeaderList.length === 0 || !this.teamLeaderList[0].phone || this.teamLeaderList[0].phone.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Maklumat Tidak Lengkap',
          text: 'Sila masukkan nombor telefon ketua pasukan.',
        });
        return;
      }
      const validationError = this.validateMandatoryFields();
      if (validationError) {
        Swal.fire({
          icon: 'error',
          title: 'Maklumat Tidak Lengkap',
          text: validationError,
        });
        return;
      }
      if (this.isSubmitting) return;
      if (action === 'baru') {
        const result = await Swal.fire({
          icon: 'question',
          title: 'Hantar Inisiatif',
          text: 'Adakah anda ingin menilai inisiatif ini?',
          showCancelButton: true,
          confirmButtonText: 'Ya, Hantar',
          cancelButtonText: 'Batal',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
        });
        if (!result.isConfirmed) return;
      }
      try {
        this.isSubmitting = true;
        await this.saveSelectedCriteria();
        const formData = new FormData();
        if (!this.project.state) {
          Swal.fire({
            icon: 'error',
            title: 'Maklumat Tidak Lengkap',
            text: 'Sila pilih lokasi inisiatif.',
          });
          return;
        }
        formData.append('id', this.$route.params.id);
        // formData.append('video_link', this.videoLinks.filter(link => link.trim()).join(','));
        formData.append('name', this.project.name || '');
        formData.append('description', this.project.description || '');
        formData.append('problem', this.project.problem || '');
        formData.append('proposal_result', this.project.proposal_result || '');
        formData.append('project_cost', this.project.project_cost || '0');
        formData.append('video_link', this.prepareVideoLinks());
        formData.append('testimoni', this.project.testimoni || '');
        formData.append('ministry', this.project.ministry || '');
        formData.append('agency', this.project.agency || '');
        // formData.append('state', this.project.state || null);
        const stateCode = this.project.state ? (this.findStateCode(this.project.state) || this.project.state) : null;
        // console.log('Appending state_code:', stateCode);
        formData.append('state_code', stateCode || '');
        formData.append('project_year', this.project.project_year || '');
        formData.append('category_id', this.project.category_id || '');
        formData.append('team_leader', JSON.stringify(this.teamLeaderList));
        formData.append('team_members', JSON.stringify(this.teamMembersList));
        formData.append('before_project', JSON.stringify(this.beforeProjectList));
        formData.append('after_project', JSON.stringify(this.afterProjectList));
        formData.append('criteria', JSON.stringify(this.criteria.map(c => ({
          name: c.name,
          selected: c.selected,
          verified: c.verified,
        }))));
        formData.append('outputs', JSON.stringify(this.selectedOutput ? [this.selectedOutput] : []));
        formData.append('action', action);
        const newImages = this.project.images.filter(image => image instanceof File);
        const existingImages = this.project.images
          .filter(image => image.url && !(this.project.imagesToDelete || []).includes(image.url))
          .map(image => image.url);
        newImages.forEach((image, index) => {
          formData.append('images[]', image);
        });
        formData.append('existing_images', JSON.stringify(existingImages));
        const newTestimoniImages = this.project.testimoni_images.filter(image => image instanceof File);
        const existingTestimoniImages = this.project.testimoni_images
          .filter(image => image.url && !(this.project.testimoniImagesToDelete || []).includes(image.url))
          .map(image => image.url);
        newTestimoniImages.forEach((image, index) => {
          formData.append('testimoni_images[]', image);
        });
        formData.append('existing_testimoni_images', JSON.stringify(existingTestimoniImages));
        if (this.project.imagesToDelete) {
          formData.append('images_to_delete', JSON.stringify(this.project.imagesToDelete));
        }
        if (this.project.testimoniImagesToDelete) {
          formData.append('testimoni_images_to_delete', JSON.stringify(this.project.testimoniImagesToDelete));
        }
        if (this.project.slide_url instanceof File) {
          formData.append('slide_pdf', this.project.slide_url);
          if (this.project.slideToDelete) {
            formData.append('slide_to_delete', this.project.slideToDelete);
          }
        } else if (this.project.slide_url === null && this.project.slideToDelete) {
          formData.append('slide_to_delete', this.project.slideToDelete);
        } else if (typeof this.project.slide_url === 'string') {
          formData.append('existing_slide_url', this.project.slide_url);
        }
        for (let [key, value] of formData.entries()) {
          // console.log(key, value);
        }
        const response = await axios.post(baseURL + '/kemaskini_view_projek.php', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (response.data.status === 'success') {
          Swal.fire({
            icon: 'success',
            title: action === 'draf' ? 'Inisiatif Berjaya Disimpan!' : 'Inisiatif Berjaya Dihantar!',
            text: this.project.slideToDelete ? 'Slaid PDF telah dipadam.' : this.project.slide_url instanceof File ? 'Slaid PDF baru telah dimuat naik.' : '',
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.project.slideToDelete = null;
            this.project.imagesToDelete = [];
            this.project.testimoniImagesToDelete = [];
            this.isEditMode = false;
            this.fetchProjectDetails();
            this.$router.push('/senarai-projek');
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Ralat!',
            text: response.data.message || 'Terdapat ralat semasa menyimpan inisiatif.',
          });
        }
      } catch (error) {
        // console.error('Error submitting project:', error);
        let errorMessage = 'Terdapat ralat semasa menyimpan inisiatif.';
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || `Ralat dari server: ${error.response.status}`;
          // console.error('Server error details:', error.response.data);
        } else if (error.request) {
          errorMessage = 'Tiada sambungan ke server. Sila semak sambungan internet anda.';
        } else {
          errorMessage = `Ralat: ${error.message}`;
        }
        Swal.fire({
          icon: 'error',
          title: 'Ralat!',
          text: errorMessage,
        });
      } finally {
        this.isSubmitting = false;
      }
    },
  }
};
</script>

<style scoped>
#main {
  background-color: #f5f5f5;
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
}

.tab-content-bg {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
}

.attached-files {
  margin-top: 10px;
}

.attached-files .list-group-item {
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.drop-area {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

.drop-area:hover,
.drop-area.dragging {
  border-color: #007bff;
}

.drop-area p {
  margin: 0;
  font-size: 14px;
  color: #6c757d;
}

.hidden-file-input {
  display: none;
}

.form-text.text-danger {
  font-size: 12px;
}

.ml-2 {
  margin-left: 0.5rem;
}

.tooltip-custom {
  position: absolute;
  top: -10px;
  left: 20%;
  transform: translateX(-50%) translateY(-100%);
  background-color: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 12px;
  white-space: normal;
  width: 300px;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  text-align: left;
}

.tooltip-custom::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.85) transparent transparent transparent;
}

.list-group-item:hover .tooltip-custom {
  opacity: 1;
  visibility: visible;
}

.team-leader-list .list-group-item,
.team-members-list .list-group-item,
.before-project-list .list-group-item,
.after-project-list .list-group-item {
  padding: 12px;
  border-radius: 6px;
  background-color: #f8f9fa;
  transition: background-color 0.3s ease;
}

.team-leader-list .list-group-item:hover,
.team-members-list .list-group-item:hover {
  background-color: #e9ecef;
}

.btn-sm {
  font-size: 12px;
  padding: 4px 8px;
}

.btn-outline-secondary.mt-2 {
  margin-top: 0.5rem;
}

.attachment-group {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}

.attachment-item {
  margin-bottom: 15px;
}

.attachment-item:last-child {
  margin-bottom: 0;
}

.image-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.image-card {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.image-card:hover {
  transform: scale(2);
  z-index: 10;
}

.image-title {
  font-size: 16px;
  margin-bottom: 10px;
  text-align: center;
  font-weight: bold;
}

.project-image-zoom {
  max-width: 200px;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
}

.no-image-text {
  font-size: 14px;
  color: #6c757d;
  margin-top: 10px;
  text-align: center;
}

@media (max-width: 768px) {
  .project-image-zoom {
    max-width: 150px;
  }

  .image-card:hover {
    transform: scale(1.5);
  }
}

#project_cost {
  text-align: left;
  font-weight: bold;
}

#proposal_result {
  resize: vertical;
}

.secretariat-header {
  background: black;
  color: white;
  padding: 8px;
  font-weight: bold;
  font-size: 16px;
}

.custom-dropdown {
  max-width: 250px;
  border-radius: 8px;
  border: 1px solid #ced4da;
  padding: 5px;
}

.pdf-viewer-container {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.output-checkboxes {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
}

.output-checkboxes .custom-control {
  margin-bottom: 5px;
}

.comment-textarea {
  min-height: 100px;
  border-radius: 8px;
  border: 1px solid #ced4da;
  padding: 10px;
}

.comment-textarea:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.text-danger {
  color: rgb(0, 0, 0);
}

.form-control:required,
.custom-select:required {
  border-left: 3px solid #000000;
  padding-left: 5px;
}

/* Team Leader and Member Specific Styles */
.team-leader-list .list-group-item div,
.team-members-list .list-group-item div {
  flex-grow: 1;
}

.team-leader-list .small,
.team-members-list .small {
  font-size: 0.85rem;
}

.team-leader-list .text-muted,
.team-members-list .text-muted {
  color: #6c757d !important;
}

/* Icon Styling */
.icon-leader,
.icon-member,
.icon-id,
.icon-email,
.icon-phone,
.icon-extension {
  margin-right: 8px;
  transition: color 0.3s ease, transform 0.3s ease;
}

/* Specific Icon Colors */
.icon-leader,
.icon-member {
  color: #007bff;
  font-size: 1.2rem;
}

.icon-id {
  color: #28a745;
}

.icon-email {
  color: #6f42c1;
}

.icon-phone {
  color: #17a2b8;
}

.icon-extension {
  color: #6c757d;
}

/* Hover Effects */
.team-leader-list .list-group-item:hover .icon-leader,
.team-members-list .list-group-item:hover .icon-member {
  color: #0056b3;
  transform: scale(1.1);
}

.team-leader-list .list-group-item:hover .icon-id,
.team-members-list .list-group-item:hover .icon-id {
  color: #218838;
  transform: scale(1.1);
}

.team-leader-list .list-group-item:hover .icon-email {
  color: #6f42c1;
  transform: scale(1.1);
}

.team-leader-list .list-group-item:hover .icon-phone {
  color: #138496;
  transform: scale(1.1);
}

.team-leader-list .list-group-item:hover .icon-extension {
  color: #5a6268;
  transform: scale(1.1);
}

/* Align Icons and Text */
.leader-name,
.member-name,
.team-leader-list .small,
.team-members-list .small {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

/* Button Styling */
.btn-danger.btn-sm {
  padding: 4px 10px;
  font-size: 0.85rem;
  border-radius: 4px;
}

.custom-outline-btn {
  border: 1px solid;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.custom-outline-btn.leader {
  border-color: #28a745;
  color: #28a745;
}

.custom-outline-btn.leader:hover {
  border-color: #218838;
  color: #218838;
}

.custom-outline-btn.member {
  border-color: #007bff;
  color: #007bff;
}

.custom-outline-btn.member:hover {
  border-color: #0056b3;
  color: #0056b3;
}

.form-control:required,
.custom-select:required {
  border-left: 3px solid #dc3545;
  padding-left: 5px;
}

.star-rating {
  display: inline-flex;
  align-items: center;
}

.rating-star {
  font-size: 1rem;
  /* Adjusted from 1.2rem to 1rem for smaller stars */
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: 2px;
}

.rating-star:hover {
  transform: scale(1.2);
}

.text-warning {
  color: #ffc107 !important;
}

.fa-star-o:before {
  content: "\f006";
  /* Star outline */
}

.fa-star:before {
  content: "\f005";
  /* Solid star */
}

.fa-star-o:before {
  content: "\f006";
  /* Star outline */
}

.fa-star:before {
  content: "\f005";
  /* Solid star */
}

.overall-rating {
  font-size: 18px;
  font-weight: bold;
  color: #007bff;
}

.text-danger {
  color: #dc3545 !important;
}

.form-control:required,
.custom-select:required {
  border-left: 3px solid #dc3545;
  padding-left: 5px;
}

/* Tindakan Sekretariat */
.secretariat-header {
  background-color: #343a40;
  color: white;
  padding: 10px 15px;
  font-weight: bold;
  font-size: 16px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  text-align: center;
  /* Center the header text */
  width: 100%;
  /* Ensure it spans the full width of the parent */
}

.secretariat-header {
  background-color: #343a40;
  color: white;
  padding: 10px 15px;
  font-weight: bold;
  font-size: 16px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.secretariat-content {
  background-color: white;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 20px;
}

.rating-summary {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  border-left: 4px solid #6c757d;
}

.rating-item {
  display: flex;
  flex-direction: column;
}

.rating-label {
  font-size: 14px;
  color: #6c757d;
}

.rating-value {
  font-size: 16px;
  font-weight: bold;
}

.text-orange {
  color: #fd7e14;
}

.status-section {
  margin-top: 20px;
}

.word-count {
  font-size: 13px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .rating-summary {
    padding: 12px;
  }

  .rating-item {
    margin-right: 15px !important;
    margin-bottom: 10px !important;
  }
}

/* Penilaian Inisiatif Section */
.penilaian-projek-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  padding: 20px 0;
}

.penilaian-projek-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 100%;
  max-width: 600px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.penilaian-projek-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.penilaian-projek-title {
  font-size: 20px;
  font-weight: bold;
  color: #343a40;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.penilaian-projek-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.rating-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  min-width: 150px;
}

.rating-label {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
  margin-bottom: 5px;
}

.rating-value {
  font-size: 18px;
  font-weight: bold;
  color: #007bff;
}

.rating-value.text-success {
  color: #28a745 !important;
}

.rating-value.text-primary {
  color: #007bff !important;
}

.rating-value.text-warning {
  color: #ffc107 !important;
}

.rating-value.text-orange {
  color: #fd7e14 !important;
}

.rating-value.text-danger {
  color: #dc3545 !important;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .penilaian-projek-card {
    padding: 15px;
    max-width: 90%;
  }

  .penilaian-projek-title {
    font-size: 18px;
  }

  .rating-item {
    min-width: 120px;
  }

  .rating-value {
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .penilaian-projek-content {
    flex-direction: column;
    gap: 15px;
  }

  .rating-item {
    min-width: 100%;
  }
}

.status-section .form-group p {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 500;
}

.text-success {
  color: #28a745 !important;
}

.text-danger {
  color: #dc3545 !important;
}

.text-muted {
  color: #6c757d !important;
}

/* Dalam style, tambahkan styling untuk ikon reset */
.reset-rating {
  color: #6c757d;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.reset-rating:hover {
  color: #dc3545;
  transform: rotate(-90deg);
}

.star-rating {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.rating-star {
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.rating-star:hover {
  transform: scale(1.2);
}

.rating-star.rating-1 {
  color: #dc3545 !important;
  /* Warna merah untuk rating 1 */
}

.rating-star.rating-1:hover {
  transform: scale(1.3);
  /* Efek hover lebih besar untuk rating 1 */
}

.rating-info {
  font-size: 0.8rem;
  margin-top: 5px;
  color: #6c757d;
  /* Warna text-muted */
}

.rating-info i {
  margin-right: 5px;
}

.custom-select:disabled {
  background-color: #ffffff !important;
  color: #495057 !important;
  opacity: 1 !important;
  border-color: #ced4da !important;
}

/* For BootstrapVue specific select */
.form-control:disabled {
  background-color: #ffffff !important;
  color: #495057 !important;
  opacity: 1 !important;
  border-color: #ced4da !important;
}

/* Ensure dropdown options remain white */
select:disabled {
  background-color: #ffffff !important;
  color: #495057 !important;
}

/* Override any gray background from Bootstrap */
.b-form-select:disabled {
  background-color: #ffffff !important;
  color: #495057 !important;
  opacity: 1 !important;
}
</style>
